/*
IMPORTANT
This file is auto-generated.
Do not make manual changes.
Manual changes will be overwritten when the file is next generated.

API:          IBSS API
Version:      2
Description:  IBSS API provides app calls for mobile and panel apps.
Generated at: 23-06-2025 15:19 (India Standard Time)
*/

import axios, { AxiosError, AxiosResponse } from 'axios';
import { ApiError } from '../Providers.Api/ApiError';
import { ODataSelect } from '../Providers.Api/ODataQuery';
import { IRawPagedResponse, IRawPagedResponse3, PagedResponse } from '../Providers.Api/Models';
import { ApiHelper } from '../Providers.Api/ApiHelper';
import { IbssRequestConfig } from '../Providers.Api/ApiClient';

export interface IContext
{
    baseUrl: string;
}

export interface IIbssApiClientV2
{
    v2: IIbssApiClientV2_V2;


}

export class IbssApiClientV2 implements IIbssApiClientV2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.v2 = new IbssApiClientV2_V2(context);
    }

    public v2: IbssApiClientV2_V2;


}

export interface IIbssApiClientV2_V2
{
    byNodeid: IIbssApiClientV2_V2_ByNodeid;
    configuration: IIbssApiClientV2_V2_Configuration;
    roles: IIbssApiClientV2_V2_Roles;
    users: IIbssApiClientV2_V2_Users;


}

export class IbssApiClientV2_V2 implements IIbssApiClientV2_V2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byNodeid = new IbssApiClientV2_V2_ByNodeid(context);
        this.configuration = new IbssApiClientV2_V2_Configuration(context);
        this.roles = new IbssApiClientV2_V2_Roles(context);
        this.users = new IbssApiClientV2_V2_Users(context);
    }

    public byNodeid: IbssApiClientV2_V2_ByNodeid;
    public configuration: IbssApiClientV2_V2_Configuration;
    public roles: IbssApiClientV2_V2_Roles;
    public users: IbssApiClientV2_V2_Users;


}

export interface IIbssApiClientV2_V2_ByNodeid
{
    announcements: IIbssApiClientV2_V2_ByNodeid_Announcements;
    bookingparties: IIbssApiClientV2_V2_ByNodeid_Bookingparties;
    bookingpolicies: IIbssApiClientV2_V2_ByNodeid_Bookingpolicies;
    bookings: IIbssApiClientV2_V2_ByNodeid_Bookings;
    bookingsSummary: IIbssApiClientV2_V2_ByNodeid_BookingsSummary;
    cateringMenu: IIbssApiClientV2_V2_ByNodeid_CateringMenu;
    cateringMenuitem: IIbssApiClientV2_V2_ByNodeid_CateringMenuitem;
    cateringTemplates: IIbssApiClientV2_V2_ByNodeid_CateringTemplates;
    cateringOrder: IIbssApiClientV2_V2_ByNodeid_CateringOrder;
    cateringOrderPolicy: IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy;
    cateringRestriction: IIbssApiClientV2_V2_ByNodeid_CateringRestriction;
    cateringSupplier: IIbssApiClientV2_V2_ByNodeid_CateringSupplier;
    costcodes: IIbssApiClientV2_V2_ByNodeid_Costcodes;
    dataPoints: IIbssApiClientV2_V2_ByNodeid_DataPoints;
    equipment: IIbssApiClientV2_V2_ByNodeid_Equipment;
    exportRequests: IIbssApiClientV2_V2_ByNodeid_ExportRequests;
    filters: IIbssApiClientV2_V2_ByNodeid_Filters;
    nodes: IIbssApiClientV2_V2_ByNodeid_Nodes;
    notes: IIbssApiClientV2_V2_ByNodeid_Notes;
    notificationReminders: IIbssApiClientV2_V2_ByNodeid_NotificationReminders;
    resolversCategories: IIbssApiClientV2_V2_ByNodeid_ResolversCategories;
    shortcuts: IIbssApiClientV2_V2_ByNodeid_Shortcuts;
    spaces: IIbssApiClientV2_V2_ByNodeid_Spaces;
    tag2Eventtype: IIbssApiClientV2_V2_ByNodeid_Tag2Eventtype;
    tags: IIbssApiClientV2_V2_ByNodeid_Tags;
    taskCategories: IIbssApiClientV2_V2_ByNodeid_TaskCategories;
    tasks: IIbssApiClientV2_V2_ByNodeid_Tasks;
    taskTypes: IIbssApiClientV2_V2_ByNodeid_TaskTypes;
    ticketedevents: IIbssApiClientV2_V2_ByNodeid_Ticketedevents;
    userNotifications: IIbssApiClientV2_V2_ByNodeid_UserNotifications;
    visitorTypes: IIbssApiClientV2_V2_ByNodeid_VisitorTypes;
    visits: IIbssApiClientV2_V2_ByNodeid_Visits;


}

export class IbssApiClientV2_V2_ByNodeid implements IIbssApiClientV2_V2_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.announcements = new IbssApiClientV2_V2_ByNodeid_Announcements(context);
        this.bookingparties = new IbssApiClientV2_V2_ByNodeid_Bookingparties(context);
        this.bookingpolicies = new IbssApiClientV2_V2_ByNodeid_Bookingpolicies(context);
        this.bookings = new IbssApiClientV2_V2_ByNodeid_Bookings(context);
        this.bookingsSummary = new IbssApiClientV2_V2_ByNodeid_BookingsSummary(context);
        this.cateringMenu = new IbssApiClientV2_V2_ByNodeid_CateringMenu(context);
        this.cateringMenuitem = new IbssApiClientV2_V2_ByNodeid_CateringMenuitem(context);
        this.cateringTemplates = new IbssApiClientV2_V2_ByNodeid_CateringTemplates(context);
        this.cateringOrder = new IbssApiClientV2_V2_ByNodeid_CateringOrder(context);
        this.cateringOrderPolicy = new IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy(context);
        this.cateringRestriction = new IbssApiClientV2_V2_ByNodeid_CateringRestriction(context);
        this.cateringSupplier = new IbssApiClientV2_V2_ByNodeid_CateringSupplier(context);
        this.costcodes = new IbssApiClientV2_V2_ByNodeid_Costcodes(context);
        this.dataPoints = new IbssApiClientV2_V2_ByNodeid_DataPoints(context);
        this.equipment = new IbssApiClientV2_V2_ByNodeid_Equipment(context);
        this.exportRequests = new IbssApiClientV2_V2_ByNodeid_ExportRequests(context);
        this.filters = new IbssApiClientV2_V2_ByNodeid_Filters(context);
        this.nodes = new IbssApiClientV2_V2_ByNodeid_Nodes(context);
        this.notes = new IbssApiClientV2_V2_ByNodeid_Notes(context);
        this.notificationReminders = new IbssApiClientV2_V2_ByNodeid_NotificationReminders(context);
        this.resolversCategories = new IbssApiClientV2_V2_ByNodeid_ResolversCategories(context);
        this.shortcuts = new IbssApiClientV2_V2_ByNodeid_Shortcuts(context);
        this.spaces = new IbssApiClientV2_V2_ByNodeid_Spaces(context);
        this.tag2Eventtype = new IbssApiClientV2_V2_ByNodeid_Tag2Eventtype(context);
        this.tags = new IbssApiClientV2_V2_ByNodeid_Tags(context);
        this.taskCategories = new IbssApiClientV2_V2_ByNodeid_TaskCategories(context);
        this.tasks = new IbssApiClientV2_V2_ByNodeid_Tasks(context);
        this.taskTypes = new IbssApiClientV2_V2_ByNodeid_TaskTypes(context);
        this.ticketedevents = new IbssApiClientV2_V2_ByNodeid_Ticketedevents(context);
        this.userNotifications = new IbssApiClientV2_V2_ByNodeid_UserNotifications(context);
        this.visitorTypes = new IbssApiClientV2_V2_ByNodeid_VisitorTypes(context);
        this.visits = new IbssApiClientV2_V2_ByNodeid_Visits(context);
    }

    public announcements: IbssApiClientV2_V2_ByNodeid_Announcements;
    public bookingparties: IbssApiClientV2_V2_ByNodeid_Bookingparties;
    public bookingpolicies: IbssApiClientV2_V2_ByNodeid_Bookingpolicies;
    public bookings: IbssApiClientV2_V2_ByNodeid_Bookings;
    public bookingsSummary: IbssApiClientV2_V2_ByNodeid_BookingsSummary;
    public cateringMenu: IbssApiClientV2_V2_ByNodeid_CateringMenu;
    public cateringMenuitem: IbssApiClientV2_V2_ByNodeid_CateringMenuitem;
    public cateringTemplates: IbssApiClientV2_V2_ByNodeid_CateringTemplates;
    public cateringOrder: IbssApiClientV2_V2_ByNodeid_CateringOrder;
    public cateringOrderPolicy: IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy;
    public cateringRestriction: IbssApiClientV2_V2_ByNodeid_CateringRestriction;
    public cateringSupplier: IbssApiClientV2_V2_ByNodeid_CateringSupplier;
    public costcodes: IbssApiClientV2_V2_ByNodeid_Costcodes;
    public dataPoints: IbssApiClientV2_V2_ByNodeid_DataPoints;
    public equipment: IbssApiClientV2_V2_ByNodeid_Equipment;
    public exportRequests: IbssApiClientV2_V2_ByNodeid_ExportRequests;
    public filters: IbssApiClientV2_V2_ByNodeid_Filters;
    public nodes: IbssApiClientV2_V2_ByNodeid_Nodes;
    public notes: IbssApiClientV2_V2_ByNodeid_Notes;
    public notificationReminders: IbssApiClientV2_V2_ByNodeid_NotificationReminders;
    public resolversCategories: IbssApiClientV2_V2_ByNodeid_ResolversCategories;
    public shortcuts: IbssApiClientV2_V2_ByNodeid_Shortcuts;
    public spaces: IbssApiClientV2_V2_ByNodeid_Spaces;
    public tag2Eventtype: IbssApiClientV2_V2_ByNodeid_Tag2Eventtype;
    public tags: IbssApiClientV2_V2_ByNodeid_Tags;
    public taskCategories: IbssApiClientV2_V2_ByNodeid_TaskCategories;
    public tasks: IbssApiClientV2_V2_ByNodeid_Tasks;
    public taskTypes: IbssApiClientV2_V2_ByNodeid_TaskTypes;
    public ticketedevents: IbssApiClientV2_V2_ByNodeid_Ticketedevents;
    public userNotifications: IbssApiClientV2_V2_ByNodeid_UserNotifications;
    public visitorTypes: IbssApiClientV2_V2_ByNodeid_VisitorTypes;
    public visits: IbssApiClientV2_V2_ByNodeid_Visits;


}

export interface IIbssApiClientV2_V2_ByNodeid_Announcements
{
    byAnnouncementid: IIbssApiClientV2_V2_ByNodeid_Announcements_ByAnnouncementid;
    active: IIbssApiClientV2_V2_ByNodeid_Announcements_Active;
    byId: IIbssApiClientV2_V2_ByNodeid_Announcements_ById;
    classifications: IIbssApiClientV2_V2_ByNodeid_Announcements_Classifications;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IAnnouncementRequestVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Announcements implements IIbssApiClientV2_V2_ByNodeid_Announcements
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byAnnouncementid = new IbssApiClientV2_V2_ByNodeid_Announcements_ByAnnouncementid(context);
        this.active = new IbssApiClientV2_V2_ByNodeid_Announcements_Active(context);
        this.byId = new IbssApiClientV2_V2_ByNodeid_Announcements_ById(context);
        this.classifications = new IbssApiClientV2_V2_ByNodeid_Announcements_Classifications(context);
    }

    public byAnnouncementid: IbssApiClientV2_V2_ByNodeid_Announcements_ByAnnouncementid;
    public active: IbssApiClientV2_V2_ByNodeid_Announcements_Active;
    public byId: IbssApiClientV2_V2_ByNodeid_Announcements_ById;
    public classifications: IbssApiClientV2_V2_ByNodeid_Announcements_Classifications;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/announcements?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IAnnouncementRequestVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/announcements?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Announcements_ByAnnouncementid
{

    delete<TResponse>(options: { nodeId: number, announcementid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, announcementid: number, body: IAnnouncementRequestVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Announcements_ByAnnouncementid implements IIbssApiClientV2_V2_ByNodeid_Announcements_ByAnnouncementid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, announcementid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/announcements/${options.announcementid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, announcementid: number, body: IAnnouncementRequestVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/announcements/${options.announcementid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Announcements_Active
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Announcements_Active implements IIbssApiClientV2_V2_ByNodeid_Announcements_Active
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/announcements/active?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Announcements_ById
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Announcements_ById implements IIbssApiClientV2_V2_ByNodeid_Announcements_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/announcements/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Announcements_Classifications
{

    get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Announcements_Classifications implements IIbssApiClientV2_V2_ByNodeid_Announcements_Classifications
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/announcements/classifications?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingparties
{
    byRecordid: IIbssApiClientV2_V2_ByNodeid_Bookingparties_ByRecordid;
    delete: IIbssApiClientV2_V2_ByNodeid_Bookingparties_Delete;
    bookingsSeries: IIbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries;
    import: IIbssApiClientV2_V2_ByNodeid_Bookingparties_Import;
    download: IIbssApiClientV2_V2_ByNodeid_Bookingparties_Download;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, bookingid?: string, body: IBookingParticipant[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingparties implements IIbssApiClientV2_V2_ByNodeid_Bookingparties
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byRecordid = new IbssApiClientV2_V2_ByNodeid_Bookingparties_ByRecordid(context);
        this.delete = new IbssApiClientV2_V2_ByNodeid_Bookingparties_Delete(context);
        this.bookingsSeries = new IbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries(context);
        this.import = new IbssApiClientV2_V2_ByNodeid_Bookingparties_Import(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_Bookingparties_Download(context);
    }

    public byRecordid: IbssApiClientV2_V2_ByNodeid_Bookingparties_ByRecordid;
    public delete: IbssApiClientV2_V2_ByNodeid_Bookingparties_Delete;
    public bookingsSeries: IbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries;
    public import: IbssApiClientV2_V2_ByNodeid_Bookingparties_Import;
    public download: IbssApiClientV2_V2_ByNodeid_Bookingparties_Download;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, bookingid?: string, body: IBookingParticipant[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.bookingid) { queryParts.push(`bookingid=${encodeURIComponent(options.bookingid)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingparties_ByRecordid
{

    delete<TResponse>(options: { nodeId: number, recordid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, recordid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, recordid: string, body: IPatchParty, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingparties_ByRecordid implements IIbssApiClientV2_V2_ByNodeid_Bookingparties_ByRecordid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, recordid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties/${options.recordid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, recordid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties/${options.recordid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, recordid: string, body: IPatchParty, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties/${options.recordid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingparties_Delete
{

    patch<TResponse>(options: { nodeId: number, body: IPatchBulkDelete[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingparties_Delete implements IIbssApiClientV2_V2_ByNodeid_Bookingparties_Delete
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: IPatchBulkDelete[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties/delete?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries
{
    byBookingSeriesId: IIbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries_ByBookingSeriesId;


}

export class IbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries implements IIbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byBookingSeriesId = new IbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries_ByBookingSeriesId(context);
    }

    public byBookingSeriesId: IbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries_ByBookingSeriesId;


}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries_ByBookingSeriesId
{

    post<TResponse>(options: { nodeId: number, bookingSeriesId: string, body: IBookingParticipant[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries_ByBookingSeriesId implements IIbssApiClientV2_V2_ByNodeid_Bookingparties_BookingsSeries_ByBookingSeriesId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, bookingSeriesId: string, body: IBookingParticipant[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties/bookings-series/${options.bookingSeriesId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingparties_Import
{
    byBookingid: IIbssApiClientV2_V2_ByNodeid_Bookingparties_Import_ByBookingid;


}

export class IbssApiClientV2_V2_ByNodeid_Bookingparties_Import implements IIbssApiClientV2_V2_ByNodeid_Bookingparties_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byBookingid = new IbssApiClientV2_V2_ByNodeid_Bookingparties_Import_ByBookingid(context);
    }

    public byBookingid: IbssApiClientV2_V2_ByNodeid_Bookingparties_Import_ByBookingid;


}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingparties_Import_ByBookingid
{

    post<TResponse>(options: { nodeId: number, bookingid: string, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingparties_Import_ByBookingid implements IIbssApiClientV2_V2_ByNodeid_Bookingparties_Import_ByBookingid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, bookingid: string, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties/import/${options.bookingid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingparties_Download
{

    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingparties_Download implements IIbssApiClientV2_V2_ByNodeid_Bookingparties_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/bookingparties/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingpolicies
{
    byBookingpolicyid: IIbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IBookingPolicy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingpolicies implements IIbssApiClientV2_V2_ByNodeid_Bookingpolicies
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byBookingpolicyid = new IbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid(context);
    }

    public byBookingpolicyid: IbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookingpolicies?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IBookingPolicy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/bookingpolicies?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid
{
    apply: IIbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid_Apply;

    delete<TResponse>(options: { nodeId: number, bookingpolicyid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, bookingpolicyid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, bookingpolicyid: string, body: IBookingPolicy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid implements IIbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.apply = new IbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid_Apply(context);
    }

    public apply: IbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid_Apply;


    public async delete<TResponse>(options: { nodeId: number, bookingpolicyid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/bookingpolicies/${options.bookingpolicyid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, bookingpolicyid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookingpolicies/${options.bookingpolicyid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, bookingpolicyid: string, body: IBookingPolicy, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/bookingpolicies/${options.bookingpolicyid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid_Apply
{

    patch<TResponse>(options: { nodeId: number, bookingpolicyid: string, body: IBookingPolicyApply, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid_Apply implements IIbssApiClientV2_V2_ByNodeid_Bookingpolicies_ByBookingpolicyid_Apply
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, bookingpolicyid: string, body: IBookingPolicyApply, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookingpolicies/${options.bookingpolicyid}/Apply?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings
{
    historical: IIbssApiClientV2_V2_ByNodeid_Bookings_Historical;
    myPrimariesBookings: IIbssApiClientV2_V2_ByNodeid_Bookings_MyPrimariesBookings;
    myBookings: IIbssApiClientV2_V2_ByNodeid_Bookings_MyBookings;
    bookingsSeries: IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries;
    byBookingid: IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid;
    download: IIbssApiClientV2_V2_ByNodeid_Bookings_Download;
    getErrorResponse: IIbssApiClientV2_V2_ByNodeid_Bookings_GetErrorResponse;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, showDebugStats?: boolean, body: ISpaceBookRequestV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings implements IIbssApiClientV2_V2_ByNodeid_Bookings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.historical = new IbssApiClientV2_V2_ByNodeid_Bookings_Historical(context);
        this.myPrimariesBookings = new IbssApiClientV2_V2_ByNodeid_Bookings_MyPrimariesBookings(context);
        this.myBookings = new IbssApiClientV2_V2_ByNodeid_Bookings_MyBookings(context);
        this.bookingsSeries = new IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries(context);
        this.byBookingid = new IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_Bookings_Download(context);
        this.getErrorResponse = new IbssApiClientV2_V2_ByNodeid_Bookings_GetErrorResponse(context);
    }

    public historical: IbssApiClientV2_V2_ByNodeid_Bookings_Historical;
    public myPrimariesBookings: IbssApiClientV2_V2_ByNodeid_Bookings_MyPrimariesBookings;
    public myBookings: IbssApiClientV2_V2_ByNodeid_Bookings_MyBookings;
    public bookingsSeries: IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries;
    public byBookingid: IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid;
    public download: IbssApiClientV2_V2_ByNodeid_Bookings_Download;
    public getErrorResponse: IbssApiClientV2_V2_ByNodeid_Bookings_GetErrorResponse;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, showDebugStats?: boolean, body: ISpaceBookRequestV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/bookings?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_Historical
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_Historical implements IIbssApiClientV2_V2_ByNodeid_Bookings_Historical
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/historical?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_MyPrimariesBookings
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, primary?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_MyPrimariesBookings implements IIbssApiClientV2_V2_ByNodeid_Bookings_MyPrimariesBookings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, primary?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.primary) { queryParts.push(`primary=${encodeURIComponent(options.primary)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/my-primaries-bookings?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_MyBookings
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_MyBookings implements IIbssApiClientV2_V2_ByNodeid_Bookings_MyBookings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/my-bookings?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries
{
    bySeriesid: IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid;


}

export class IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries implements IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySeriesid = new IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid(context);
    }

    public bySeriesid: IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid;


}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid
{
    cancel: IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid_Cancel;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, seriesid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, seriesid: string, body: IBookingUpdateDetailsRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, seriesid: string, body: IUpdateBookingV2BookingDates, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid implements IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.cancel = new IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid_Cancel(context);
    }

    public cancel: IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid_Cancel;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, seriesid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/bookings-series/${options.seriesid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, seriesid: string, body: IBookingUpdateDetailsRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/bookings-series/${options.seriesid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, seriesid: string, body: IUpdateBookingV2BookingDates, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/bookings-series/${options.seriesid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid
{
    notes: IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Notes;
    tags: IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Tags;
    deny: IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Deny;
    approve: IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Approve;
    cancel: IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Cancel;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, bookingid: string, showDebugStats?: boolean, body: IPatchUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, bookingid: string, showDebugStats?: boolean, body: IUpdateBookingV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid implements IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.notes = new IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Notes(context);
        this.tags = new IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Tags(context);
        this.deny = new IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Deny(context);
        this.approve = new IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Approve(context);
        this.cancel = new IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Cancel(context);
    }

    public notes: IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Notes;
    public tags: IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Tags;
    public deny: IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Deny;
    public approve: IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Approve;
    public cancel: IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Cancel;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/${options.bookingid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, bookingid: string, showDebugStats?: boolean, body: IPatchUpdate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/${options.bookingid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, bookingid: string, showDebugStats?: boolean, body: IUpdateBookingV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/${options.bookingid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Notes
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Notes implements IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Notes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/${options.bookingid}/notes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Tags
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Tags implements IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Tags
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/${options.bookingid}/tags?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, dataType?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_Download implements IIbssApiClientV2_V2_ByNodeid_Bookings_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, dataType?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.dataType) { queryParts.push(`dataType=${encodeURIComponent(options.dataType)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_GetErrorResponse
{

    get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_GetErrorResponse implements IIbssApiClientV2_V2_ByNodeid_Bookings_GetErrorResponse
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/GetErrorResponse?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Deny
{

    patch<TResponse>(options: { nodeId: number, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Deny implements IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Deny
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/${options.bookingid}/deny?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Approve
{

    patch<TResponse>(options: { nodeId: number, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Approve implements IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Approve
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, bookingid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/${options.bookingid}/approve?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid_Cancel
{

    patch<TResponse>(options: { nodeId: number, seriesid: string, disableExtUpdate?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid_Cancel implements IIbssApiClientV2_V2_ByNodeid_Bookings_BookingsSeries_BySeriesid_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, seriesid: string, disableExtUpdate?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/bookings-series/${options.seriesid}/cancel?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Cancel
{

    patch<TResponse>(options: { nodeId: number, bookingid: string, disableExtUpdate?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Cancel implements IIbssApiClientV2_V2_ByNodeid_Bookings_ByBookingid_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, bookingid: string, disableExtUpdate?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/bookings/${options.bookingid}/cancel?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_BookingsSummary
{
    dailyRequest: IIbssApiClientV2_V2_ByNodeid_BookingsSummary_DailyRequest;


}

export class IbssApiClientV2_V2_ByNodeid_BookingsSummary implements IIbssApiClientV2_V2_ByNodeid_BookingsSummary
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.dailyRequest = new IbssApiClientV2_V2_ByNodeid_BookingsSummary_DailyRequest(context);
    }

    public dailyRequest: IbssApiClientV2_V2_ByNodeid_BookingsSummary_DailyRequest;


}

export interface IIbssApiClientV2_V2_ByNodeid_BookingsSummary_DailyRequest
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_BookingsSummary_DailyRequest implements IIbssApiClientV2_V2_ByNodeid_BookingsSummary_DailyRequest
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/bookings-summary/daily request?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenu
{
    byCateringMenuId: IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId;
    download: IIbssApiClientV2_V2_ByNodeid_CateringMenu_Download;
    import: IIbssApiClientV2_V2_ByNodeid_CateringMenu_Import;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICateringMenuModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenu implements IIbssApiClientV2_V2_ByNodeid_CateringMenu
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byCateringMenuId = new IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_CateringMenu_Download(context);
        this.import = new IbssApiClientV2_V2_ByNodeid_CateringMenu_Import(context);
    }

    public byCateringMenuId: IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId;
    public download: IbssApiClientV2_V2_ByNodeid_CateringMenu_Download;
    public import: IbssApiClientV2_V2_ByNodeid_CateringMenu_Import;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICateringMenuModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId
{
    roles: IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Roles;
    menuItems: IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_MenuItems;
    spaces: IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Spaces;

    delete<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, cateringMenuId: string, body: ICateringMenuModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, cateringMenuId: string, body: ICateringMenuModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId implements IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.roles = new IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Roles(context);
        this.menuItems = new IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_MenuItems(context);
        this.spaces = new IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Spaces(context);
    }

    public roles: IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Roles;
    public menuItems: IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_MenuItems;
    public spaces: IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Spaces;


    public async delete<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, cateringMenuId: string, body: ICateringMenuModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, cateringMenuId: string, body: ICateringMenuModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Roles
{

    delete<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, recursive?: boolean, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Roles implements IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/roles?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/roles?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_MenuItems
{

    delete<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, recursive?: boolean, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_MenuItems implements IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_MenuItems
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/menu-items?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/menu-items?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/menu-items?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/menu-items?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Spaces
{

    delete<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Spaces implements IIbssApiClientV2_V2_ByNodeid_CateringMenu_ByCateringMenuId_Spaces
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/spaces?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, cateringMenuId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/spaces?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/spaces?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, cateringMenuId: string, body: IRelationIdsPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/${options.cateringMenuId}/spaces?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenu_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenu_Download implements IIbssApiClientV2_V2_ByNodeid_CateringMenu_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenu_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenu_Import implements IIbssApiClientV2_V2_ByNodeid_CateringMenu_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menu/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenuitem
{
    byCateringMenuItemId: IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByCateringMenuItemId;
    byMenuItemId: IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId;
    download: IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_Download;
    import: IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_Import;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICateringMenuItemModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenuitem implements IIbssApiClientV2_V2_ByNodeid_CateringMenuitem
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byCateringMenuItemId = new IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByCateringMenuItemId(context);
        this.byMenuItemId = new IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_CateringMenuitem_Download(context);
        this.import = new IbssApiClientV2_V2_ByNodeid_CateringMenuitem_Import(context);
    }

    public byCateringMenuItemId: IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByCateringMenuItemId;
    public byMenuItemId: IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId;
    public download: IbssApiClientV2_V2_ByNodeid_CateringMenuitem_Download;
    public import: IbssApiClientV2_V2_ByNodeid_CateringMenuitem_Import;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICateringMenuItemModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByCateringMenuItemId
{

    delete<TResponse>(options: { nodeId: number, cateringMenuItemId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, cateringMenuItemId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, cateringMenuItemId: string, body: ICateringMenuItemModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, cateringMenuItemId: string, body: ICateringMenuItemModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByCateringMenuItemId implements IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByCateringMenuItemId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, cateringMenuItemId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/${options.cateringMenuItemId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, cateringMenuItemId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/${options.cateringMenuItemId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, cateringMenuItemId: string, body: ICateringMenuItemModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/${options.cateringMenuItemId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, cateringMenuItemId: string, body: ICateringMenuItemModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/${options.cateringMenuItemId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId
{
    cateringRestrictions: IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId_CateringRestrictions;


}

export class IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId implements IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.cateringRestrictions = new IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId_CateringRestrictions(context);
    }

    public cateringRestrictions: IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId_CateringRestrictions;


}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId_CateringRestrictions
{

    delete<TResponse>(options: { nodeId: number, menuItemId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, recursive?: boolean, menuItemId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, menuItemId: string, body: IRelationIdsPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, menuItemId: string, body: IRelationIdsPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId_CateringRestrictions implements IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_ByMenuItemId_CateringRestrictions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, menuItemId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/${options.menuItemId}/catering-restrictions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, menuItemId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/${options.menuItemId}/catering-restrictions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, menuItemId: string, body: IRelationIdsPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/${options.menuItemId}/catering-restrictions?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, menuItemId: string, body: IRelationIdsPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/${options.menuItemId}/catering-restrictions?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenuitem_Download implements IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringMenuitem_Import implements IIbssApiClientV2_V2_ByNodeid_CateringMenuitem_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-menuitem/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringTemplates
{
    byId: IIbssApiClientV2_V2_ByNodeid_CateringTemplates_ById;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICateringMenuTemplateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringTemplates implements IIbssApiClientV2_V2_ByNodeid_CateringTemplates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_CateringTemplates_ById(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_CateringTemplates_ById;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-templates?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICateringMenuTemplateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-templates?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringTemplates_ById
{

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: ICateringMenuTemplateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringTemplates_ById implements IIbssApiClientV2_V2_ByNodeid_CateringTemplates_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-templates/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-templates/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: ICateringMenuTemplateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/catering-templates/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder
{
    byOrderId: IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId;
    download: IIbssApiClientV2_V2_ByNodeid_CateringOrder_Download;
    byOrderid: IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid;
    bySpaceid: IIbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICateringOrderModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder implements IIbssApiClientV2_V2_ByNodeid_CateringOrder
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byOrderId = new IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_CateringOrder_Download(context);
        this.byOrderid = new IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid(context);
        this.bySpaceid = new IbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid(context);
    }

    public byOrderId: IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId;
    public download: IbssApiClientV2_V2_ByNodeid_CateringOrder_Download;
    public byOrderid: IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid;
    public bySpaceid: IbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICateringOrderModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId
{
    chargeStatus: IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ChargeStatus;
    actionRequired: IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ActionRequired;
    enable: IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Enable;
    disable: IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Disable;

    delete<TResponse>(options: { nodeId: number, orderId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, orderId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, orderId: string, body: ICateringOrderModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, orderId: string, body: ICateringOrderModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.chargeStatus = new IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ChargeStatus(context);
        this.actionRequired = new IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ActionRequired(context);
        this.enable = new IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Enable(context);
        this.disable = new IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Disable(context);
    }

    public chargeStatus: IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ChargeStatus;
    public actionRequired: IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ActionRequired;
    public enable: IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Enable;
    public disable: IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Disable;


    public async delete<TResponse>(options: { nodeId: number, orderId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, orderId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, orderId: string, body: ICateringOrderModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, orderId: string, body: ICateringOrderModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_Download implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid
{
    orderItems: IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_OrderItems;
    editOrderItems: IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_EditOrderItems;


}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.orderItems = new IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_OrderItems(context);
        this.editOrderItems = new IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_EditOrderItems(context);
    }

    public orderItems: IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_OrderItems;
    public editOrderItems: IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_EditOrderItems;


}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_OrderItems
{

    get<TResponse>(options: { nodeId: number, orderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, orderid: number, body: ICateringMenu[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_OrderItems implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_OrderItems
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, orderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderid}/order-items?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, orderid: number, body: ICateringMenu[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderid}/order-items?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_EditOrderItems
{

    get<TResponse>(options: { nodeId: number, orderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_EditOrderItems implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderid_EditOrderItems
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, orderid: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderid}/edit-order-items?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid
{
    newOrderItems: IIbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid_NewOrderItems;


}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.newOrderItems = new IbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid_NewOrderItems(context);
    }

    public newOrderItems: IbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid_NewOrderItems;


}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid_NewOrderItems
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid_NewOrderItems implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_BySpaceid_NewOrderItems
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.spaceid}/new-order-items?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ChargeStatus
{

    patch<TResponse>(options: { nodeId: number, orderId: string, body: ICateringOrderChargeableModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ChargeStatus implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ChargeStatus
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, orderId: string, body: ICateringOrderChargeableModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderId}/charge-status?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ActionRequired
{

    patch<TResponse>(options: { nodeId: number, orderId: string, body: ICateringOrderActionRequiredModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ActionRequired implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_ActionRequired
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, orderId: string, body: ICateringOrderActionRequiredModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderId}/action-required?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Enable
{

    patch<TResponse>(options: { nodeId: number, orderId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Enable implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, orderId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderId}/Enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Disable
{

    patch<TResponse>(options: { nodeId: number, orderId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Disable implements IIbssApiClientV2_V2_ByNodeid_CateringOrder_ByOrderId_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, orderId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order/${options.orderId}/Disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy
{
    byCateringOrderPolicyId: IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_ByCateringOrderPolicyId;
    download: IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Download;
    import: IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Import;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICateringOrderPolicyModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy implements IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byCateringOrderPolicyId = new IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_ByCateringOrderPolicyId(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Download(context);
        this.import = new IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Import(context);
    }

    public byCateringOrderPolicyId: IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_ByCateringOrderPolicyId;
    public download: IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Download;
    public import: IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Import;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICateringOrderPolicyModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_ByCateringOrderPolicyId
{

    delete<TResponse>(options: { nodeId: number, cateringOrderPolicyId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, cateringOrderPolicyId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, cateringOrderPolicyId: string, body: ICateringOrderPolicyModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, cateringOrderPolicyId: string, body: ICateringOrderPolicyModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_ByCateringOrderPolicyId implements IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_ByCateringOrderPolicyId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, cateringOrderPolicyId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy/${options.cateringOrderPolicyId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, cateringOrderPolicyId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy/${options.cateringOrderPolicyId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, cateringOrderPolicyId: string, body: ICateringOrderPolicyModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy/${options.cateringOrderPolicyId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, cateringOrderPolicyId: string, body: ICateringOrderPolicyModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy/${options.cateringOrderPolicyId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Download implements IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Import implements IIbssApiClientV2_V2_ByNodeid_CateringOrderPolicy_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-order-policy/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringRestriction
{
    byCateringRestrictionId: IIbssApiClientV2_V2_ByNodeid_CateringRestriction_ByCateringRestrictionId;
    download: IIbssApiClientV2_V2_ByNodeid_CateringRestriction_Download;
    import: IIbssApiClientV2_V2_ByNodeid_CateringRestriction_Import;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICateringRestrictionModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringRestriction implements IIbssApiClientV2_V2_ByNodeid_CateringRestriction
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byCateringRestrictionId = new IbssApiClientV2_V2_ByNodeid_CateringRestriction_ByCateringRestrictionId(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_CateringRestriction_Download(context);
        this.import = new IbssApiClientV2_V2_ByNodeid_CateringRestriction_Import(context);
    }

    public byCateringRestrictionId: IbssApiClientV2_V2_ByNodeid_CateringRestriction_ByCateringRestrictionId;
    public download: IbssApiClientV2_V2_ByNodeid_CateringRestriction_Download;
    public import: IbssApiClientV2_V2_ByNodeid_CateringRestriction_Import;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICateringRestrictionModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringRestriction_ByCateringRestrictionId
{

    delete<TResponse>(options: { nodeId: number, cateringRestrictionId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, cateringRestrictionId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, cateringRestrictionId: string, body: ICateringRestrictionModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, cateringRestrictionId: string, body: ICateringRestrictionModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringRestriction_ByCateringRestrictionId implements IIbssApiClientV2_V2_ByNodeid_CateringRestriction_ByCateringRestrictionId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, cateringRestrictionId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction/${options.cateringRestrictionId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, cateringRestrictionId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction/${options.cateringRestrictionId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, cateringRestrictionId: string, body: ICateringRestrictionModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction/${options.cateringRestrictionId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, cateringRestrictionId: string, body: ICateringRestrictionModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction/${options.cateringRestrictionId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringRestriction_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringRestriction_Download implements IIbssApiClientV2_V2_ByNodeid_CateringRestriction_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringRestriction_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringRestriction_Import implements IIbssApiClientV2_V2_ByNodeid_CateringRestriction_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-restriction/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringSupplier
{
    byCateringSupplierId: IIbssApiClientV2_V2_ByNodeid_CateringSupplier_ByCateringSupplierId;
    bySupplierId: IIbssApiClientV2_V2_ByNodeid_CateringSupplier_BySupplierId;
    download: IIbssApiClientV2_V2_ByNodeid_CateringSupplier_Download;
    import: IIbssApiClientV2_V2_ByNodeid_CateringSupplier_Import;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ICateringSupplierModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringSupplier implements IIbssApiClientV2_V2_ByNodeid_CateringSupplier
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byCateringSupplierId = new IbssApiClientV2_V2_ByNodeid_CateringSupplier_ByCateringSupplierId(context);
        this.bySupplierId = new IbssApiClientV2_V2_ByNodeid_CateringSupplier_BySupplierId(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_CateringSupplier_Download(context);
        this.import = new IbssApiClientV2_V2_ByNodeid_CateringSupplier_Import(context);
    }

    public byCateringSupplierId: IbssApiClientV2_V2_ByNodeid_CateringSupplier_ByCateringSupplierId;
    public bySupplierId: IbssApiClientV2_V2_ByNodeid_CateringSupplier_BySupplierId;
    public download: IbssApiClientV2_V2_ByNodeid_CateringSupplier_Download;
    public import: IbssApiClientV2_V2_ByNodeid_CateringSupplier_Import;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ICateringSupplierModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringSupplier_ByCateringSupplierId
{

    delete<TResponse>(options: { nodeId: number, cateringSupplierId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, cateringSupplierId: string, body: ICateringSupplierModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, cateringSupplierId: string, body: ICateringSupplierModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringSupplier_ByCateringSupplierId implements IIbssApiClientV2_V2_ByNodeid_CateringSupplier_ByCateringSupplierId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, cateringSupplierId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier/${options.cateringSupplierId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, cateringSupplierId: string, body: ICateringSupplierModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier/${options.cateringSupplierId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, cateringSupplierId: string, body: ICateringSupplierModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier/${options.cateringSupplierId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringSupplier_BySupplierId
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, supplierId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringSupplier_BySupplierId implements IIbssApiClientV2_V2_ByNodeid_CateringSupplier_BySupplierId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, supplierId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier/${options.supplierId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringSupplier_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringSupplier_Download implements IIbssApiClientV2_V2_ByNodeid_CateringSupplier_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_CateringSupplier_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_CateringSupplier_Import implements IIbssApiClientV2_V2_ByNodeid_CateringSupplier_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/catering-supplier/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Costcodes
{
    byCostCodeId: IIbssApiClientV2_V2_ByNodeid_Costcodes_ByCostCodeId;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Costcodes implements IIbssApiClientV2_V2_ByNodeid_Costcodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byCostCodeId = new IbssApiClientV2_V2_ByNodeid_Costcodes_ByCostCodeId(context);
    }

    public byCostCodeId: IbssApiClientV2_V2_ByNodeid_Costcodes_ByCostCodeId;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/costcodes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Costcodes_ByCostCodeId
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, costCodeId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Costcodes_ByCostCodeId implements IIbssApiClientV2_V2_ByNodeid_Costcodes_ByCostCodeId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, costCodeId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/costcodes/${options.costCodeId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_DataPoints
{
    byId: IIbssApiClientV2_V2_ByNodeid_DataPoints_ById;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IDataPoint, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_DataPoints implements IIbssApiClientV2_V2_ByNodeid_DataPoints
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_DataPoints_ById(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_DataPoints_ById;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/data-points?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IDataPoint, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/data-points?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_DataPoints_ById
{
    data: IIbssApiClientV2_V2_ByNodeid_DataPoints_ById_Data;

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: IDataPoint, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_DataPoints_ById implements IIbssApiClientV2_V2_ByNodeid_DataPoints_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.data = new IbssApiClientV2_V2_ByNodeid_DataPoints_ById_Data(context);
    }

    public data: IbssApiClientV2_V2_ByNodeid_DataPoints_ById_Data;


    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/data-points/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/data-points/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: IDataPoint, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/data-points/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_DataPoints_ById_Data
{

    post<TResponse>(options: { nodeId: number, id: string, body: IDataPointVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_DataPoints_ById_Data implements IIbssApiClientV2_V2_ByNodeid_DataPoints_ById_Data
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, id: string, body: IDataPointVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/data-points/${options.id}/data?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment
{
    byEquipid: IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid;
    byId: IIbssApiClientV2_V2_ByNodeid_Equipment_ById;
    definitions: IIbssApiClientV2_V2_ByNodeid_Equipment_Definitions;
    refresh: IIbssApiClientV2_V2_ByNodeid_Equipment_Refresh;
    search: IIbssApiClientV2_V2_ByNodeid_Equipment_Search;
    enable: IIbssApiClientV2_V2_ByNodeid_Equipment_Enable;
    disable: IIbssApiClientV2_V2_ByNodeid_Equipment_Disable;
    available: IIbssApiClientV2_V2_ByNodeid_Equipment_Available;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IEquipmentV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment implements IIbssApiClientV2_V2_ByNodeid_Equipment
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEquipid = new IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid(context);
        this.byId = new IbssApiClientV2_V2_ByNodeid_Equipment_ById(context);
        this.definitions = new IbssApiClientV2_V2_ByNodeid_Equipment_Definitions(context);
        this.refresh = new IbssApiClientV2_V2_ByNodeid_Equipment_Refresh(context);
        this.search = new IbssApiClientV2_V2_ByNodeid_Equipment_Search(context);
        this.enable = new IbssApiClientV2_V2_ByNodeid_Equipment_Enable(context);
        this.disable = new IbssApiClientV2_V2_ByNodeid_Equipment_Disable(context);
        this.available = new IbssApiClientV2_V2_ByNodeid_Equipment_Available(context);
    }

    public byEquipid: IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid;
    public byId: IbssApiClientV2_V2_ByNodeid_Equipment_ById;
    public definitions: IbssApiClientV2_V2_ByNodeid_Equipment_Definitions;
    public refresh: IbssApiClientV2_V2_ByNodeid_Equipment_Refresh;
    public search: IbssApiClientV2_V2_ByNodeid_Equipment_Search;
    public enable: IbssApiClientV2_V2_ByNodeid_Equipment_Enable;
    public disable: IbssApiClientV2_V2_ByNodeid_Equipment_Disable;
    public available: IbssApiClientV2_V2_ByNodeid_Equipment_Available;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/equipment?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IEquipmentV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/equipment?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid
{
    tasks: IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Tasks;
    definitions: IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Definitions;
    refresh: IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Refresh;
    bookings: IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Bookings;

    delete<TResponse>(options: { nodeId: number, equipid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, equipid: string, body: IEquipmentV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid implements IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.tasks = new IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Tasks(context);
        this.definitions = new IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Definitions(context);
        this.refresh = new IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Refresh(context);
        this.bookings = new IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Bookings(context);
    }

    public tasks: IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Tasks;
    public definitions: IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Definitions;
    public refresh: IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Refresh;
    public bookings: IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Bookings;


    public async delete<TResponse>(options: { nodeId: number, equipid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/${options.equipid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, equipid: string, body: IEquipmentV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/${options.equipid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_ById
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_ById implements IIbssApiClientV2_V2_ByNodeid_Equipment_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Tasks
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, equipid: string, skipToken?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Tasks implements IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Tasks
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, equipid: string, skipToken?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`skipToken=${encodeURIComponent(options.skipToken)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/${options.equipid}/tasks?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_Definitions
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, skipToken?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_Definitions implements IIbssApiClientV2_V2_ByNodeid_Equipment_Definitions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, skipToken?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/definitions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Definitions
{

    get<TResponse>(options: { nodeId: number, equipid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Definitions implements IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Definitions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, equipid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/${options.equipid}/definitions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_Refresh
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, skipToken?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_Refresh implements IIbssApiClientV2_V2_ByNodeid_Equipment_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, skipToken?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Refresh
{

    get<TResponse>(options: { nodeId: number, equipid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Refresh implements IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, equipid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/${options.equipid}/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_Search
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, skipToken?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_Search implements IIbssApiClientV2_V2_ByNodeid_Equipment_Search
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, orderBy?: string, skipToken?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.skipToken) { queryParts.push(`skipToken=${encodeURIComponent(options.skipToken)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/search?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_Enable
{

    patch<TResponse>(options: { nodeId: number, equipid?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_Enable implements IIbssApiClientV2_V2_ByNodeid_Equipment_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, equipid?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.equipid) { queryParts.push(`equipid=${encodeURIComponent(options.equipid)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_Disable
{

    patch<TResponse>(options: { nodeId: number, equipid?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_Disable implements IIbssApiClientV2_V2_ByNodeid_Equipment_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, equipid?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.equipid) { queryParts.push(`equipid=${encodeURIComponent(options.equipid)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Bookings
{

    post<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, equipid: string, skipToken?: string, body: IEquipmentBookingModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Bookings implements IIbssApiClientV2_V2_ByNodeid_Equipment_ByEquipid_Bookings
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, recursive?: boolean, top?: number, equipid: string, skipToken?: string, body: IEquipmentBookingModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`skipToken=${encodeURIComponent(options.skipToken)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/${options.equipid}/bookings?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Equipment_Available
{

    post<TResponse>(options: { nodeId: number, body: IAvailableEquipment, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Equipment_Available implements IIbssApiClientV2_V2_ByNodeid_Equipment_Available
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: IAvailableEquipment, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/equipment/available?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_ExportRequests
{
    byId: IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById;
    cancel: IIbssApiClientV2_V2_ByNodeid_ExportRequests_Cancel;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_ExportRequests implements IIbssApiClientV2_V2_ByNodeid_ExportRequests
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_ExportRequests_ById(context);
        this.cancel = new IbssApiClientV2_V2_ByNodeid_ExportRequests_Cancel(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_ExportRequests_ById;
    public cancel: IbssApiClientV2_V2_ByNodeid_ExportRequests_Cancel;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById
{
    status: IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Status;
    download: IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Download;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_ExportRequests_ById implements IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.status = new IbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Status(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Download(context);
    }

    public status: IbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Status;
    public download: IbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Download;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Status
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Status implements IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Status
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests/${options.id}/status?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Download
{

    get<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Download implements IIbssApiClientV2_V2_ByNodeid_ExportRequests_ById_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests/${options.id}/download?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_ExportRequests_Cancel
{

    patch<TResponse>(options: { nodeId: number, body: IExportRequestsCancelRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_ExportRequests_Cancel implements IIbssApiClientV2_V2_ByNodeid_ExportRequests_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: IExportRequestsCancelRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests/cancel?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Filters
{
    byFilterid: IIbssApiClientV2_V2_ByNodeid_Filters_ByFilterid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Filters implements IIbssApiClientV2_V2_ByNodeid_Filters
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byFilterid = new IbssApiClientV2_V2_ByNodeid_Filters_ByFilterid(context);
    }

    public byFilterid: IbssApiClientV2_V2_ByNodeid_Filters_ByFilterid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/filters?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/filters?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Filters_ByFilterid
{

    delete<TResponse>(options: { nodeId: number, filterid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filterid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, filterid: string, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, filterid: string, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Filters_ByFilterid implements IIbssApiClientV2_V2_ByNodeid_Filters_ByFilterid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, filterid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/filters/${options.filterid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filterid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/filters/${options.filterid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, filterid: string, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/filters/${options.filterid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, filterid: string, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/filters/${options.filterid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration
{
    nodes: IIbssApiClientV2_V2_Configuration_Nodes;
    byNodeid: IIbssApiClientV2_V2_Configuration_ByNodeid;


}

export class IbssApiClientV2_V2_Configuration implements IIbssApiClientV2_V2_Configuration
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.nodes = new IbssApiClientV2_V2_Configuration_Nodes(context);
        this.byNodeid = new IbssApiClientV2_V2_Configuration_ByNodeid(context);
    }

    public nodes: IbssApiClientV2_V2_Configuration_Nodes;
    public byNodeid: IbssApiClientV2_V2_Configuration_ByNodeid;


}

export interface IIbssApiClientV2_V2_Configuration_Nodes
{
    byNodeid: IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid;
    levels: IIbssApiClientV2_V2_Configuration_Nodes_Levels;
    download: IIbssApiClientV2_V2_Configuration_Nodes_Download;
    import: IIbssApiClientV2_V2_Configuration_Nodes_Import;
    byNodeId: IIbssApiClientV2_V2_Configuration_Nodes_ByNodeId;

    get<TResponse>(options: { recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { body: IHierarchyNodesRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_Nodes implements IIbssApiClientV2_V2_Configuration_Nodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byNodeid = new IbssApiClientV2_V2_Configuration_Nodes_ByNodeid(context);
        this.levels = new IbssApiClientV2_V2_Configuration_Nodes_Levels(context);
        this.download = new IbssApiClientV2_V2_Configuration_Nodes_Download(context);
        this.import = new IbssApiClientV2_V2_Configuration_Nodes_Import(context);
        this.byNodeId = new IbssApiClientV2_V2_Configuration_Nodes_ByNodeId(context);
    }

    public byNodeid: IbssApiClientV2_V2_Configuration_Nodes_ByNodeid;
    public levels: IbssApiClientV2_V2_Configuration_Nodes_Levels;
    public download: IbssApiClientV2_V2_Configuration_Nodes_Download;
    public import: IbssApiClientV2_V2_Configuration_Nodes_Import;
    public byNodeId: IbssApiClientV2_V2_Configuration_Nodes_ByNodeId;


    public async get<TResponse>(options: { recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/configuration/nodes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IHierarchyNodesRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/configuration/nodes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid
{
    enable: IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Enable;
    disable: IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Disable;

    delete<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, body: IHierarchyNodesPatchRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_Nodes_ByNodeid implements IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.enable = new IbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Enable(context);
        this.disable = new IbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Disable(context);
    }

    public enable: IbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Enable;
    public disable: IbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Disable;


    public async delete<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/configuration/nodes/${options.nodeId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/configuration/nodes/${options.nodeId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, body: IHierarchyNodesPatchRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/configuration/nodes/${options.nodeId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_Nodes_Levels
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_Nodes_Levels implements IIbssApiClientV2_V2_Configuration_Nodes_Levels
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/configuration/nodes/levels?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_Nodes_Download
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_Nodes_Download implements IIbssApiClientV2_V2_Configuration_Nodes_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/configuration/nodes/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Enable
{

    patch<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Enable implements IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/configuration/nodes/${options.nodeId}/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Disable
{

    patch<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Disable implements IIbssApiClientV2_V2_Configuration_Nodes_ByNodeid_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/configuration/nodes/${options.nodeId}/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_Nodes_Import
{

    post<TResponse>(options: { body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_Nodes_Import implements IIbssApiClientV2_V2_Configuration_Nodes_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/configuration/nodes/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_Nodes_ByNodeId
{

    put<TResponse>(options: { nodeId: number, body: IHierarchyNodesRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_Nodes_ByNodeId implements IIbssApiClientV2_V2_Configuration_Nodes_ByNodeId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { nodeId: number, body: IHierarchyNodesRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/configuration/nodes/${options.nodeId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Nodes
{
    spaceTypes: IIbssApiClientV2_V2_ByNodeid_Nodes_SpaceTypes;


}

export class IbssApiClientV2_V2_ByNodeid_Nodes implements IIbssApiClientV2_V2_ByNodeid_Nodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.spaceTypes = new IbssApiClientV2_V2_ByNodeid_Nodes_SpaceTypes(context);
    }

    public spaceTypes: IbssApiClientV2_V2_ByNodeid_Nodes_SpaceTypes;


}

export interface IIbssApiClientV2_V2_ByNodeid_Nodes_SpaceTypes
{

    get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Nodes_SpaceTypes implements IIbssApiClientV2_V2_ByNodeid_Nodes_SpaceTypes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/nodes/space-types?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Notes
{
    byNoteid: IIbssApiClientV2_V2_ByNodeid_Notes_ByNoteid;
    download: IIbssApiClientV2_V2_ByNodeid_Notes_Download;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: INotesRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Notes implements IIbssApiClientV2_V2_ByNodeid_Notes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byNoteid = new IbssApiClientV2_V2_ByNodeid_Notes_ByNoteid(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_Notes_Download(context);
    }

    public byNoteid: IbssApiClientV2_V2_ByNodeid_Notes_ByNoteid;
    public download: IbssApiClientV2_V2_ByNodeid_Notes_Download;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: INotesRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/notes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Notes_ByNoteid
{
    cancel: IIbssApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, noteid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, noteid: string, body: INotesRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Notes_ByNoteid implements IIbssApiClientV2_V2_ByNodeid_Notes_ByNoteid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.cancel = new IbssApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel(context);
    }

    public cancel: IbssApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, noteid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notes/${options.noteid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, noteid: string, body: INotesRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/notes/${options.noteid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Notes_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, dataType?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Notes_Download implements IIbssApiClientV2_V2_ByNodeid_Notes_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, dataType?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.dataType) { queryParts.push(`dataType=${encodeURIComponent(options.dataType)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notes/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/notes/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel
{

    patch<TResponse>(options: { nodeId: number, noteid: string, body: INotesSoftDeleteRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel implements IIbssApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, noteid: string, body: INotesSoftDeleteRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/notes/${options.noteid}/cancel?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_NotificationReminders
{
    byId: IIbssApiClientV2_V2_ByNodeid_NotificationReminders_ById;
    enable: IIbssApiClientV2_V2_ByNodeid_NotificationReminders_Enable;
    disable: IIbssApiClientV2_V2_ByNodeid_NotificationReminders_Disable;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: INotificationReminder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_NotificationReminders implements IIbssApiClientV2_V2_ByNodeid_NotificationReminders
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_NotificationReminders_ById(context);
        this.enable = new IbssApiClientV2_V2_ByNodeid_NotificationReminders_Enable(context);
        this.disable = new IbssApiClientV2_V2_ByNodeid_NotificationReminders_Disable(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_NotificationReminders_ById;
    public enable: IbssApiClientV2_V2_ByNodeid_NotificationReminders_Enable;
    public disable: IbssApiClientV2_V2_ByNodeid_NotificationReminders_Disable;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: INotificationReminder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_NotificationReminders_ById
{

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: INotificationReminder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_NotificationReminders_ById implements IIbssApiClientV2_V2_ByNodeid_NotificationReminders_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: INotificationReminder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_NotificationReminders_Enable
{

    patch<TResponse>(options: { nodeId: number, body: INotificationReminderEnable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_NotificationReminders_Enable implements IIbssApiClientV2_V2_ByNodeid_NotificationReminders_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: INotificationReminderEnable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_NotificationReminders_Disable
{

    patch<TResponse>(options: { nodeId: number, body: INotificationReminderDisable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_NotificationReminders_Disable implements IIbssApiClientV2_V2_ByNodeid_NotificationReminders_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: INotificationReminderDisable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_ResolversCategories
{
    byId: IIbssApiClientV2_V2_ByNodeid_ResolversCategories_ById;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IResolverCategory, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_ResolversCategories implements IIbssApiClientV2_V2_ByNodeid_ResolversCategories
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_ResolversCategories_ById(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_ResolversCategories_ById;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/resolvers-categories?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IResolverCategory, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/resolvers-categories?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_ResolversCategories_ById
{

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: IResolverCategory, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_ResolversCategories_ById implements IIbssApiClientV2_V2_ByNodeid_ResolversCategories_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/resolvers-categories/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/resolvers-categories/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: IResolverCategory, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/resolvers-categories/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Roles
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Roles implements IIbssApiClientV2_V2_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Shortcuts
{
    byId: IIbssApiClientV2_V2_ByNodeid_Shortcuts_ById;
    refresh: IIbssApiClientV2_V2_ByNodeid_Shortcuts_Refresh;
    enable: IIbssApiClientV2_V2_ByNodeid_Shortcuts_Enable;
    disable: IIbssApiClientV2_V2_ByNodeid_Shortcuts_Disable;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IShortcutsRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Shortcuts implements IIbssApiClientV2_V2_ByNodeid_Shortcuts
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_Shortcuts_ById(context);
        this.refresh = new IbssApiClientV2_V2_ByNodeid_Shortcuts_Refresh(context);
        this.enable = new IbssApiClientV2_V2_ByNodeid_Shortcuts_Enable(context);
        this.disable = new IbssApiClientV2_V2_ByNodeid_Shortcuts_Disable(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_Shortcuts_ById;
    public refresh: IbssApiClientV2_V2_ByNodeid_Shortcuts_Refresh;
    public enable: IbssApiClientV2_V2_ByNodeid_Shortcuts_Enable;
    public disable: IbssApiClientV2_V2_ByNodeid_Shortcuts_Disable;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IShortcutsRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Shortcuts_ById
{
    refresh: IIbssApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh;

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: IShortcutsRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Shortcuts_ById implements IIbssApiClientV2_V2_ByNodeid_Shortcuts_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.refresh = new IbssApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh(context);
    }

    public refresh: IbssApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh;


    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: IShortcutsRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Shortcuts_Refresh
{

    get<TResponse>(options: { nodeId: number, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Shortcuts_Refresh implements IIbssApiClientV2_V2_ByNodeid_Shortcuts_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh
{

    get<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh implements IIbssApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/${options.id}/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Shortcuts_Enable
{

    patch<TResponse>(options: { nodeId: number, body: IShortcutsEnableRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Shortcuts_Enable implements IIbssApiClientV2_V2_ByNodeid_Shortcuts_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: IShortcutsEnableRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Shortcuts_Disable
{

    patch<TResponse>(options: { nodeId: number, body: IShortcutsEnableRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Shortcuts_Disable implements IIbssApiClientV2_V2_ByNodeid_Shortcuts_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: IShortcutsEnableRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces
{
    byId: IIbssApiClientV2_V2_ByNodeid_Spaces_ById;
    bySpaceid: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid;
    search: IIbssApiClientV2_V2_ByNodeid_Spaces_Search;
    download: IIbssApiClientV2_V2_ByNodeid_Spaces_Download;
    disable: IIbssApiClientV2_V2_ByNodeid_Spaces_Disable;
    enable: IIbssApiClientV2_V2_ByNodeid_Spaces_Enable;
    searchRecurring: IIbssApiClientV2_V2_ByNodeid_Spaces_SearchRecurring;
    byStoreid: IIbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid;
    import: IIbssApiClientV2_V2_ByNodeid_Spaces_Import;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ISpace, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces implements IIbssApiClientV2_V2_ByNodeid_Spaces
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_Spaces_ById(context);
        this.bySpaceid = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid(context);
        this.search = new IbssApiClientV2_V2_ByNodeid_Spaces_Search(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_Spaces_Download(context);
        this.disable = new IbssApiClientV2_V2_ByNodeid_Spaces_Disable(context);
        this.enable = new IbssApiClientV2_V2_ByNodeid_Spaces_Enable(context);
        this.searchRecurring = new IbssApiClientV2_V2_ByNodeid_Spaces_SearchRecurring(context);
        this.byStoreid = new IbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid(context);
        this.import = new IbssApiClientV2_V2_ByNodeid_Spaces_Import(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_Spaces_ById;
    public bySpaceid: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid;
    public search: IbssApiClientV2_V2_ByNodeid_Spaces_Search;
    public download: IbssApiClientV2_V2_ByNodeid_Spaces_Download;
    public disable: IbssApiClientV2_V2_ByNodeid_Spaces_Disable;
    public enable: IbssApiClientV2_V2_ByNodeid_Spaces_Enable;
    public searchRecurring: IbssApiClientV2_V2_ByNodeid_Spaces_SearchRecurring;
    public byStoreid: IbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid;
    public import: IbssApiClientV2_V2_ByNodeid_Spaces_Import;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ISpace, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/spaces?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_ById
{
    bookingsOnThisDay: IIbssApiClientV2_V2_ByNodeid_Spaces_ById_BookingsOnThisDay;
    cateringMenu: IIbssApiClientV2_V2_ByNodeid_Spaces_ById_CateringMenu;
    checkin: IIbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkin;
    checkout: IIbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkout;

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, id: string, body: ISpacePatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: ISpace, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_ById implements IIbssApiClientV2_V2_ByNodeid_Spaces_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bookingsOnThisDay = new IbssApiClientV2_V2_ByNodeid_Spaces_ById_BookingsOnThisDay(context);
        this.cateringMenu = new IbssApiClientV2_V2_ByNodeid_Spaces_ById_CateringMenu(context);
        this.checkin = new IbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkin(context);
        this.checkout = new IbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkout(context);
    }

    public bookingsOnThisDay: IbssApiClientV2_V2_ByNodeid_Spaces_ById_BookingsOnThisDay;
    public cateringMenu: IbssApiClientV2_V2_ByNodeid_Spaces_ById_CateringMenu;
    public checkin: IbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkin;
    public checkout: IbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkout;


    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, id: string, body: ISpacePatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: ISpace, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid
{
    store: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store;
    spaceInfo: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_SpaceInfo;
    bookingPolicy: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_BookingPolicy;
    stores: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Stores;
    servicedSpacesByStore: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_ServicedSpacesByStore;
    equipmentInUse: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInUse;
    equipmentInStore: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInStore;


}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.store = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store(context);
        this.spaceInfo = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_SpaceInfo(context);
        this.bookingPolicy = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_BookingPolicy(context);
        this.stores = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Stores(context);
        this.servicedSpacesByStore = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_ServicedSpacesByStore(context);
        this.equipmentInUse = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInUse(context);
        this.equipmentInStore = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInStore(context);
    }

    public store: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store;
    public spaceInfo: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_SpaceInfo;
    public bookingPolicy: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_BookingPolicy;
    public stores: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Stores;
    public servicedSpacesByStore: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_ServicedSpacesByStore;
    public equipmentInUse: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInUse;
    public equipmentInStore: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInStore;


}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store
{
    byStoreid: IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store_ByStoreid;


}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byStoreid = new IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store_ByStoreid(context);
    }

    public byStoreid: IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store_ByStoreid;


}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store_ByStoreid
{

    delete<TResponse>(options: { nodeId: number, spaceid: string, storeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store_ByStoreid implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Store_ByStoreid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, spaceid: string, storeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.spaceid}/store/${options.storeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_SpaceInfo
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_SpaceInfo implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_SpaceInfo
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.spaceid}/space-info?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_ById_BookingsOnThisDay
{

    get<TResponse>(options: { nodeId: number, top?: number, id: string, calendarDay?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_ById_BookingsOnThisDay implements IIbssApiClientV2_V2_ByNodeid_Spaces_ById_BookingsOnThisDay
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, top?: number, id: string, calendarDay?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.calendarDay) { queryParts.push(`calendar-day=${encodeURIComponent(options.calendarDay)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.id}/bookings-on-this-day?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_Search
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, forceTop?: boolean, primary?: string, timeInclusive?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, top?: number, skipToken?: string, showDebugStats?: boolean, body: ISearchRecurring, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_Search implements IIbssApiClientV2_V2_ByNodeid_Spaces_Search
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, forceTop?: boolean, primary?: string, timeInclusive?: boolean, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skiptoken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.forceTop) { queryParts.push(`forceTop=${encodeURIComponent(options.forceTop)}`);}
            if (options.primary) { queryParts.push(`primary=${encodeURIComponent(options.primary)}`);}
            if (options.timeInclusive) { queryParts.push(`timeInclusive=${encodeURIComponent(options.timeInclusive)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/search?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, top?: number, skipToken?: string, showDebugStats?: boolean, body: ISearchRecurring, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skiptoken=${encodeURIComponent(options.skipToken)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/search?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_BookingPolicy
{

    get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_BookingPolicy implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_BookingPolicy
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.spaceid}/booking-policy?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Stores
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Stores implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_Stores
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.spaceid}/stores?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_ServicedSpacesByStore
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_ServicedSpacesByStore implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_ServicedSpacesByStore
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.spaceid}/serviced-spaces-by-store?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInUse
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInUse implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInUse
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.spaceid}/equipment-in-use?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInStore
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInStore implements IIbssApiClientV2_V2_ByNodeid_Spaces_BySpaceid_EquipmentInStore
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, spaceid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.spaceid}/equipment-in-store?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_Download implements IIbssApiClientV2_V2_ByNodeid_Spaces_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_ById_CateringMenu
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_ById_CateringMenu implements IIbssApiClientV2_V2_ByNodeid_Spaces_ById_CateringMenu
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.id}/catering-menu?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_Disable
{

    patch<TResponse>(options: { nodeId: number, body: ISpaceDisableVM[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_Disable implements IIbssApiClientV2_V2_ByNodeid_Spaces_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: ISpaceDisableVM[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_Enable
{

    patch<TResponse>(options: { nodeId: number, body: ISpaceEnableVM[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_Enable implements IIbssApiClientV2_V2_ByNodeid_Spaces_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: ISpaceEnableVM[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkin
{

    patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, showDebugStats?: boolean, body: ISpaceBookingActionVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkin implements IIbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkin
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, showDebugStats?: boolean, body: ISpaceBookingActionVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.id}/checkin?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkout
{

    patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, showDebugStats?: boolean, body: ISpaceBookingActionVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkout implements IIbssApiClientV2_V2_ByNodeid_Spaces_ById_Checkout
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, showDebugStats?: boolean, body: ISpaceBookingActionVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.id}/checkout?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_SearchRecurring
{

    post<TResponse>(options: { nodeId: number, top?: number, skipToken?: string, showDebugStats?: boolean, body: ISearchRecurring, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_SearchRecurring implements IIbssApiClientV2_V2_ByNodeid_Spaces_SearchRecurring
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, top?: number, skipToken?: string, showDebugStats?: boolean, body: ISearchRecurring, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skiptoken=${encodeURIComponent(options.skipToken)}`);}
            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/search-recurring?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid
{
    spacesToAssign: IIbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid_SpacesToAssign;


}

export class IbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid implements IIbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.spacesToAssign = new IbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid_SpacesToAssign(context);
    }

    public spacesToAssign: IbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid_SpacesToAssign;


}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid_SpacesToAssign
{

    post<TResponse>(options: { nodeId: number, storeid: string, body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid_SpacesToAssign implements IIbssApiClientV2_V2_ByNodeid_Spaces_ByStoreid_SpacesToAssign
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, storeid: string, body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/${options.storeid}/spaces-to-assign?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Spaces_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Spaces_Import implements IIbssApiClientV2_V2_ByNodeid_Spaces_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/spaces/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_ByNodeid
{
    spaces: IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces;


}

export class IbssApiClientV2_V2_Configuration_ByNodeid implements IIbssApiClientV2_V2_Configuration_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.spaces = new IbssApiClientV2_V2_Configuration_ByNodeid_Spaces(context);
    }

    public spaces: IbssApiClientV2_V2_Configuration_ByNodeid_Spaces;


}

export interface IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces
{
    bySpaceId: IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_BySpaceId;
    download: IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Download;
    byId: IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById;
    setowner: IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Setowner;
    import: IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Import;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ISpacesConfigurationRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_ByNodeid_Spaces implements IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySpaceId = new IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_BySpaceId(context);
        this.download = new IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Download(context);
        this.byId = new IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById(context);
        this.setowner = new IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Setowner(context);
        this.import = new IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Import(context);
    }

    public bySpaceId: IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_BySpaceId;
    public download: IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Download;
    public byId: IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById;
    public setowner: IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Setowner;
    public import: IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Import;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ISpacesConfigurationRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_BySpaceId
{

    delete<TResponse>(options: { nodeId: number, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, spaceId: string, body: ISpacesConfigurationRequestPatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, spaceId: string, body: ISpacesConfigurationRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_BySpaceId implements IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_BySpaceId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces/${options.spaceId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, spaceId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces/${options.spaceId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, spaceId: string, body: ISpacesConfigurationRequestPatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces/${options.spaceId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, spaceId: string, body: ISpacesConfigurationRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces/${options.spaceId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Download implements IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById
{
    cateringMenu: IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById_CateringMenu;


}

export class IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById implements IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.cateringMenu = new IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById_CateringMenu(context);
    }

    public cateringMenu: IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById_CateringMenu;


}

export interface IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById_CateringMenu
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById_CateringMenu implements IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_ById_CateringMenu
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces/${options.id}/catering-menu?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Setowner
{

    patch<TResponse>(options: { nodeId: number, body: ISpacesConfigurationRequestPatchOwner, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Setowner implements IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Setowner
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: ISpacesConfigurationRequestPatchOwner, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces/setowner?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Import implements IIbssApiClientV2_V2_Configuration_ByNodeid_Spaces_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/configuration/${options.nodeId}/spaces/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tag2Eventtype
{
    byTag2Eventtypeid: IIbssApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITag2EventTypeRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tag2Eventtype implements IIbssApiClientV2_V2_ByNodeid_Tag2Eventtype
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTag2Eventtypeid = new IbssApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid(context);
    }

    public byTag2Eventtypeid: IbssApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITag2EventTypeRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid
{

    delete<TResponse>(options: { nodeId: number, tag2Eventtypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tag2Eventtypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, tag2Eventtypeid: string, body: ITag2EventTypeRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid implements IIbssApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, tag2Eventtypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype/${options.tag2Eventtypeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tag2Eventtypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype/${options.tag2Eventtypeid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, tag2Eventtypeid: string, body: ITag2EventTypeRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype/${options.tag2Eventtypeid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tags
{
    byTagid: IIbssApiClientV2_V2_ByNodeid_Tags_ByTagid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tags implements IIbssApiClientV2_V2_ByNodeid_Tags
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTagid = new IbssApiClientV2_V2_ByNodeid_Tags_ByTagid(context);
    }

    public byTagid: IbssApiClientV2_V2_ByNodeid_Tags_ByTagid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tags?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/tags?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tags_ByTagid
{

    delete<TResponse>(options: { nodeId: number, tagid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tagid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, tagid: string, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, tagid: string, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tags_ByTagid implements IIbssApiClientV2_V2_ByNodeid_Tags_ByTagid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, tagid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/tags/${options.tagid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tagid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tags/${options.tagid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, tagid: string, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tags/${options.tagid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, tagid: string, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/tags/${options.tagid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_TaskCategories
{
    byCategoryId: IIbssApiClientV2_V2_ByNodeid_TaskCategories_ByCategoryId;
    enable: IIbssApiClientV2_V2_ByNodeid_TaskCategories_Enable;
    disable: IIbssApiClientV2_V2_ByNodeid_TaskCategories_Disable;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITaskCategories, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_TaskCategories implements IIbssApiClientV2_V2_ByNodeid_TaskCategories
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byCategoryId = new IbssApiClientV2_V2_ByNodeid_TaskCategories_ByCategoryId(context);
        this.enable = new IbssApiClientV2_V2_ByNodeid_TaskCategories_Enable(context);
        this.disable = new IbssApiClientV2_V2_ByNodeid_TaskCategories_Disable(context);
    }

    public byCategoryId: IbssApiClientV2_V2_ByNodeid_TaskCategories_ByCategoryId;
    public enable: IbssApiClientV2_V2_ByNodeid_TaskCategories_Enable;
    public disable: IbssApiClientV2_V2_ByNodeid_TaskCategories_Disable;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/task-categories?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITaskCategories, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/task-categories?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_TaskCategories_ByCategoryId
{

    delete<TResponse>(options: { nodeId: number, categoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, categoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, categoryId: string, body: ITaskCategories_PUT, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_TaskCategories_ByCategoryId implements IIbssApiClientV2_V2_ByNodeid_TaskCategories_ByCategoryId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, categoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/task-categories/${options.categoryId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, categoryId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/task-categories/${options.categoryId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, categoryId: string, body: ITaskCategories_PUT, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/task-categories/${options.categoryId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_TaskCategories_Enable
{

    patch<TResponse>(options: { nodeId: number, body: ITaskCategoryEnable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_TaskCategories_Enable implements IIbssApiClientV2_V2_ByNodeid_TaskCategories_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: ITaskCategoryEnable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/task-categories/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_TaskCategories_Disable
{

    patch<TResponse>(options: { nodeId: number, body: ITaskCategoryDisable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_TaskCategories_Disable implements IIbssApiClientV2_V2_ByNodeid_TaskCategories_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: ITaskCategoryDisable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/task-categories/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks
{
    byId: IIbssApiClientV2_V2_ByNodeid_Tasks_ById;
    download: IIbssApiClientV2_V2_ByNodeid_Tasks_Download;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITasksV2Create, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks implements IIbssApiClientV2_V2_ByNodeid_Tasks
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_Tasks_ById(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_Tasks_Download(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_Tasks_ById;
    public download: IbssApiClientV2_V2_ByNodeid_Tasks_Download;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tasks?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITasksV2Create, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/tasks?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById
{
    cancel: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Cancel;
    excludeFromCalc: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ExcludeFromCalc;
    reAllocate: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ReAllocate;
    assign: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Assign;
    setInProgress: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_SetInProgress;
    unassign: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Unassign;
    resolve: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Resolve;
    changePriority: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ChangePriority;
    comment: IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Comment;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, body: ITaskV2Update, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.cancel = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_Cancel(context);
        this.excludeFromCalc = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_ExcludeFromCalc(context);
        this.reAllocate = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_ReAllocate(context);
        this.assign = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_Assign(context);
        this.setInProgress = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_SetInProgress(context);
        this.unassign = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_Unassign(context);
        this.resolve = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_Resolve(context);
        this.changePriority = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_ChangePriority(context);
        this.comment = new IbssApiClientV2_V2_ByNodeid_Tasks_ById_Comment(context);
    }

    public cancel: IbssApiClientV2_V2_ByNodeid_Tasks_ById_Cancel;
    public excludeFromCalc: IbssApiClientV2_V2_ByNodeid_Tasks_ById_ExcludeFromCalc;
    public reAllocate: IbssApiClientV2_V2_ByNodeid_Tasks_ById_ReAllocate;
    public assign: IbssApiClientV2_V2_ByNodeid_Tasks_ById_Assign;
    public setInProgress: IbssApiClientV2_V2_ByNodeid_Tasks_ById_SetInProgress;
    public unassign: IbssApiClientV2_V2_ByNodeid_Tasks_ById_Unassign;
    public resolve: IbssApiClientV2_V2_ByNodeid_Tasks_ById_Resolve;
    public changePriority: IbssApiClientV2_V2_ByNodeid_Tasks_ById_ChangePriority;
    public comment: IbssApiClientV2_V2_ByNodeid_Tasks_ById_Comment;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, body: ITaskV2Update, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Cancel
{

    delete<TResponse>(options: { nodeId: number, id: number, body: ITasksCancel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_Cancel implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, id: number, body: ITasksCancel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { data: options.body, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/cancel?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ExcludeFromCalc
{

    patch<TResponse>(options: { nodeId: number, id: string, body: ITasksExcludeFromCalcsVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_ExcludeFromCalc implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ExcludeFromCalc
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, body: ITasksExcludeFromCalcsVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/excludeFromCalc?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ReAllocate
{

    patch<TResponse>(options: { nodeId: number, id: string, body: ITaskReAllocate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_ReAllocate implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ReAllocate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, body: ITaskReAllocate, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/re-allocate?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Assign
{

    patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, body: ITasksAssign, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_Assign implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Assign
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, body: ITasksAssign, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/assign?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_SetInProgress
{

    patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_SetInProgress implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_SetInProgress
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/set-in-progress?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Unassign
{

    patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_Unassign implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Unassign
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/unassign?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Resolve
{

    patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, body: ITaskResolve, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_Resolve implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Resolve
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, body: ITaskResolve, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/resolve?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ChangePriority
{

    patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, body: ITaskPriority, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_ChangePriority implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_ChangePriority
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, disableExtUpdate?: boolean, body: ITaskPriority, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/change-priority?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Comment
{

    patch<TResponse>(options: { nodeId: number, id: string, body: ITaskComment, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_ById_Comment implements IIbssApiClientV2_V2_ByNodeid_Tasks_ById_Comment
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, id: string, body: ITaskComment, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/${options.id}/comment?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Tasks_Download
{

    post<TResponse>(options: { nodeId: number, recursive?: boolean, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Tasks_Download implements IIbssApiClientV2_V2_ByNodeid_Tasks_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, recursive?: boolean, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/tasks/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_TaskTypes
{
    byId: IIbssApiClientV2_V2_ByNodeid_TaskTypes_ById;
    enable: IIbssApiClientV2_V2_ByNodeid_TaskTypes_Enable;
    disable: IIbssApiClientV2_V2_ByNodeid_TaskTypes_Disable;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITaskType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_TaskTypes implements IIbssApiClientV2_V2_ByNodeid_TaskTypes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_TaskTypes_ById(context);
        this.enable = new IbssApiClientV2_V2_ByNodeid_TaskTypes_Enable(context);
        this.disable = new IbssApiClientV2_V2_ByNodeid_TaskTypes_Disable(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_TaskTypes_ById;
    public enable: IbssApiClientV2_V2_ByNodeid_TaskTypes_Enable;
    public disable: IbssApiClientV2_V2_ByNodeid_TaskTypes_Disable;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/task-types?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITaskType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/task-types?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_TaskTypes_ById
{

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: ITaskType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_TaskTypes_ById implements IIbssApiClientV2_V2_ByNodeid_TaskTypes_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/task-types/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/task-types/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: ITaskType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/task-types/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_TaskTypes_Enable
{

    patch<TResponse>(options: { nodeId: number, body: ITaskTypeEnable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_TaskTypes_Enable implements IIbssApiClientV2_V2_ByNodeid_TaskTypes_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: ITaskTypeEnable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/task-types/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_TaskTypes_Disable
{

    patch<TResponse>(options: { nodeId: number, body: ITaskTypeDisable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_TaskTypes_Disable implements IIbssApiClientV2_V2_ByNodeid_TaskTypes_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: ITaskTypeDisable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/task-types/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Ticketedevents
{
    byEventid: IIbssApiClientV2_V2_ByNodeid_Ticketedevents_ByEventid;
    cancel: IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Cancel;
    participants: IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITicketedEventsRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Ticketedevents implements IIbssApiClientV2_V2_ByNodeid_Ticketedevents
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEventid = new IbssApiClientV2_V2_ByNodeid_Ticketedevents_ByEventid(context);
        this.cancel = new IbssApiClientV2_V2_ByNodeid_Ticketedevents_Cancel(context);
        this.participants = new IbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants(context);
    }

    public byEventid: IbssApiClientV2_V2_ByNodeid_Ticketedevents_ByEventid;
    public cancel: IbssApiClientV2_V2_ByNodeid_Ticketedevents_Cancel;
    public participants: IbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/ticketedevents?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITicketedEventsRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/ticketedevents?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Ticketedevents_ByEventid
{

    delete<TResponse>(options: { nodeId: number, eventid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, eventid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, eventid: string, body: ITicketedEventPatchRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, eventid: string, body: ITicketedEventsRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Ticketedevents_ByEventid implements IIbssApiClientV2_V2_ByNodeid_Ticketedevents_ByEventid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, eventid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/ticketedevents/${options.eventid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, eventid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/ticketedevents/${options.eventid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, eventid: string, body: ITicketedEventPatchRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/ticketedevents/${options.eventid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, eventid: string, body: ITicketedEventsRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/ticketedevents/${options.eventid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Cancel
{

    patch<TResponse>(options: { nodeId: number, body: ITicketedEventCancelRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Ticketedevents_Cancel implements IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: ITicketedEventCancelRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/ticketedevents/cancel?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants
{
    import: IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants_Import;


}

export class IbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants implements IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.import = new IbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants_Import(context);
    }

    public import: IbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants_Import;


}

export interface IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants_Import
{

    post<TResponse>(options: { nodeId: number, eventId?: string, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants_Import implements IIbssApiClientV2_V2_ByNodeid_Ticketedevents_Participants_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, eventId?: string, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.eventId) { queryParts.push(`eventId=${encodeURIComponent(options.eventId)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/ticketedevents/participants/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_UserNotifications
{
    byId: IIbssApiClientV2_V2_ByNodeid_UserNotifications_ById;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_UserNotifications implements IIbssApiClientV2_V2_ByNodeid_UserNotifications
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_UserNotifications_ById(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_UserNotifications_ById;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/UserNotifications?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_UserNotifications_ById
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, id: string, body: INotificationStatusV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_UserNotifications_ById implements IIbssApiClientV2_V2_ByNodeid_UserNotifications_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/UserNotifications/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, id: string, body: INotificationStatusV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/UserNotifications/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_Users
{
    checkPin: IIbssApiClientV2_V2_Users_CheckPin;


}

export class IbssApiClientV2_V2_Users implements IIbssApiClientV2_V2_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.checkPin = new IbssApiClientV2_V2_Users_CheckPin(context);
    }

    public checkPin: IbssApiClientV2_V2_Users_CheckPin;


}

export interface IIbssApiClientV2_V2_Users_CheckPin
{

    post<TResponse>(options: { body: IUserPin, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_Users_CheckPin implements IIbssApiClientV2_V2_Users_CheckPin
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { body: IUserPin, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/Users/check-pin?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_VisitorTypes
{
    byId: IIbssApiClientV2_V2_ByNodeid_VisitorTypes_ById;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IVisitorType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_VisitorTypes implements IIbssApiClientV2_V2_ByNodeid_VisitorTypes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new IbssApiClientV2_V2_ByNodeid_VisitorTypes_ById(context);
    }

    public byId: IbssApiClientV2_V2_ByNodeid_VisitorTypes_ById;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/visitor-types?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IVisitorType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visitor-types?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_VisitorTypes_ById
{

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: IVisitorType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_VisitorTypes_ById implements IIbssApiClientV2_V2_ByNodeid_VisitorTypes_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/visitor-types/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/visitor-types/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: IVisitorType, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/visitor-types/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits
{
    byVisitid: IIbssApiClientV2_V2_ByNodeid_Visits_ByVisitid;
    getWalletPass: IIbssApiClientV2_V2_ByNodeid_Visits_GetWalletPass;
    deny: IIbssApiClientV2_V2_ByNodeid_Visits_Deny;
    cancel: IIbssApiClientV2_V2_ByNodeid_Visits_Cancel;
    checkin: IIbssApiClientV2_V2_ByNodeid_Visits_Checkin;
    checkout: IIbssApiClientV2_V2_ByNodeid_Visits_Checkout;
    approve: IIbssApiClientV2_V2_ByNodeid_Visits_Approve;
    download: IIbssApiClientV2_V2_ByNodeid_Visits_Download;
    import: IIbssApiClientV2_V2_ByNodeid_Visits_Import;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, owner?: string, disableExtUpdate?: boolean, body: IPostVisitV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits implements IIbssApiClientV2_V2_ByNodeid_Visits
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byVisitid = new IbssApiClientV2_V2_ByNodeid_Visits_ByVisitid(context);
        this.getWalletPass = new IbssApiClientV2_V2_ByNodeid_Visits_GetWalletPass(context);
        this.deny = new IbssApiClientV2_V2_ByNodeid_Visits_Deny(context);
        this.cancel = new IbssApiClientV2_V2_ByNodeid_Visits_Cancel(context);
        this.checkin = new IbssApiClientV2_V2_ByNodeid_Visits_Checkin(context);
        this.checkout = new IbssApiClientV2_V2_ByNodeid_Visits_Checkout(context);
        this.approve = new IbssApiClientV2_V2_ByNodeid_Visits_Approve(context);
        this.download = new IbssApiClientV2_V2_ByNodeid_Visits_Download(context);
        this.import = new IbssApiClientV2_V2_ByNodeid_Visits_Import(context);
    }

    public byVisitid: IbssApiClientV2_V2_ByNodeid_Visits_ByVisitid;
    public getWalletPass: IbssApiClientV2_V2_ByNodeid_Visits_GetWalletPass;
    public deny: IbssApiClientV2_V2_ByNodeid_Visits_Deny;
    public cancel: IbssApiClientV2_V2_ByNodeid_Visits_Cancel;
    public checkin: IbssApiClientV2_V2_ByNodeid_Visits_Checkin;
    public checkout: IbssApiClientV2_V2_ByNodeid_Visits_Checkout;
    public approve: IbssApiClientV2_V2_ByNodeid_Visits_Approve;
    public download: IbssApiClientV2_V2_ByNodeid_Visits_Download;
    public import: IbssApiClientV2_V2_ByNodeid_Visits_Import;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/visits?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, owner?: string, disableExtUpdate?: boolean, body: IPostVisitV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.owner) { queryParts.push(`owner=${encodeURIComponent(options.owner)}`);}
            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visits?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_ByVisitid
{
    notes: IIbssApiClientV2_V2_ByNodeid_Visits_ByVisitid_Notes;

    delete<TResponse>(options: { nodeId: number, visitid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, visitid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, body: IPatchVisit, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, visitid: string, owner?: string, disableExtUpdate?: boolean, body: IPutVisitV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_ByVisitid implements IIbssApiClientV2_V2_ByNodeid_Visits_ByVisitid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.notes = new IbssApiClientV2_V2_ByNodeid_Visits_ByVisitid_Notes(context);
    }

    public notes: IbssApiClientV2_V2_ByNodeid_Visits_ByVisitid_Notes;


    public async delete<TResponse>(options: { nodeId: number, visitid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/visits/${options.visitid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, visitid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/visits/${options.visitid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, visitid: string, disableExtUpdate?: boolean, body: IPatchVisit, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/visits/${options.visitid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, visitid: string, owner?: string, disableExtUpdate?: boolean, body: IPutVisitV2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.owner) { queryParts.push(`owner=${encodeURIComponent(options.owner)}`);}
            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/visits/${options.visitid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_ByVisitid_Notes
{

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, visitid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_ByVisitid_Notes implements IIbssApiClientV2_V2_ByNodeid_Visits_ByVisitid_Notes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, visitid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/visits/${options.visitid}/notes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_GetWalletPass
{

    get<TResponse>(options: { nodeId: number, device?: PassDevice, visitId?: string, hash?: string, redirect?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_GetWalletPass implements IIbssApiClientV2_V2_ByNodeid_Visits_GetWalletPass
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, device?: PassDevice, visitId?: string, hash?: string, redirect?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.device) { queryParts.push(`device=${encodeURIComponent(options.device)}`);}
            if (options.visitId) { queryParts.push(`visitId=${encodeURIComponent(options.visitId)}`);}
            if (options.hash) { queryParts.push(`hash=${encodeURIComponent(options.hash)}`);}
            if (options.redirect) { queryParts.push(`redirect=${encodeURIComponent(options.redirect)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/visits/GetWalletPass?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_Deny
{

    post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IDenyVisitModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_Deny implements IIbssApiClientV2_V2_ByNodeid_Visits_Deny
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IDenyVisitModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visits/deny?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_Cancel
{

    post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IVisitActionModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_Cancel implements IIbssApiClientV2_V2_ByNodeid_Visits_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IVisitActionModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visits/cancel?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_Checkin
{

    post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IVisitActionModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_Checkin implements IIbssApiClientV2_V2_ByNodeid_Visits_Checkin
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IVisitActionModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visits/checkin?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_Checkout
{

    post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IVisitActionModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_Checkout implements IIbssApiClientV2_V2_ByNodeid_Visits_Checkout
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IVisitActionModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visits/checkout?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_Approve
{

    post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IApproveVisitModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_Approve implements IIbssApiClientV2_V2_ByNodeid_Visits_Approve
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, disableExtUpdate?: boolean, body: IApproveVisitModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.disableExtUpdate) { queryParts.push(`disableExtUpdate=${encodeURIComponent(options.disableExtUpdate)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visits/approve?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_Download
{

    post<TResponse>(options: { nodeId: number, recursive?: boolean, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_Download implements IIbssApiClientV2_V2_ByNodeid_Visits_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, recursive?: boolean, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visits/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IIbssApiClientV2_V2_ByNodeid_Visits_Import
{

    post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>;

}

export class IbssApiClientV2_V2_ByNodeid_Visits_Import implements IIbssApiClientV2_V2_ByNodeid_Visits_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/visits/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IAnnouncementRequestVM
{
    Notification_Id?: number;
    Notification_Title?: string | null;
    Notification_Priority?: number | null;
    Notification_Record_Id?: string | null;
    Notification_Message?: string | null;
    Notification_Short_Message?: string | null;
    Notification_Reminders?: string | null;
    Notification_Type?: number | null;
    Notification_Status?: string | null;
    Notification_User_Email?: string | null;
    Notification_Sent?: number | null;
    Notification_Target?: number | null;
    Notification_Device?: string[] | null;
    Classification?: string | null;
    Subclassification?: string | null;
    Available_From?: string | null;
    Expiry_Date?: string | null;
    ImageURI?: string | null;
    ActionURI?: string | null;

}

export interface IBookingParticipant
{
    Booking_Participant_Email?: string | null;
    Booking_Participant_Name?: string | null;
    Booking_Participant_Organisation?: string | null;
    Booking_Participant_Type?: number;
    Booking_Resource_Id?: string | null;
    IsParticipant_On_WaitingList?: number;
    DisableExtUpdate?: boolean;
    Ticketed_Event_Id?: string | null;
    VisitorTypeId?: string | null;

}

export interface IPatchParty
{
    Booking_Participant_Email?: string | null;
    Booking_Participant_Name?: string | null;
    Booking_Participant_Organisation?: string | null;
    IsParticipant_On_WaitingList?: number | null;
    DisableExtUpdate?: boolean;
    Is_Ticketed_Event?: boolean;
    VisitorTypeId?: string | null;

}

export interface IPatchBulkDelete
{
    Record_Id?: string | null;

}

export interface IExportRequestsDto
{
    Node_Id?: number;
    Select?: string | null;
    Filter?: string | null;
    Top?: number;
    Source?: string | null;

}

export interface IBookingPolicy
{
    Node_Id?: number;
    Booking_Policy_Name?: string | null;
    Booking_Policy?: IBookingPolicyVM;

}

export interface IBookingPolicyVM
{
    PolicyType?: string | null;
    BuildingId?: string | null;
    FloorId?: string | null;
    Allowed_TimeRange?: string | null;
    Booking_Policy_Description?: string | null;
    BookingSlots?: IBookingSlots;
    ArrivalPolicies?: IArrivalPolicies;
    ApprovalPolicies?: IApprovalPolicies;
    ExtendedServices?: IExtendedServices;
    BookingAttendanceControl?: string | null;
    AutomatedTemplates?: IAutomatedTemplate[] | null;

}

export interface IBookingSlots
{
    BookableTime?: IBookableTime[] | null;
    ExcludedDates?: IExcludedDate[] | null;
    BookingStart?: IBookingStart;
    BookingEnd?: IBookingEnd;
    BookingSetupTime?: number;
    BookingTearDownTime?: number;
    BookingDuration?: IBookingDuration;
    BookingHorizon?: IBookingHorizon;
    BookingRecurrence?: IBookingRecurrence;

}

export interface IBookableTime
{
    Days?: string[] | null;
    StartTime?: string | null;
    EndTime?: string | null;

}

export interface IExcludedDate
{
    Reason?: string | null;
    StartDate?: string | null;
    EndDate?: string | null;
    StartTime?: string | null;
    EndTime?: string | null;

}

export interface IBookingStart
{
    SpecificMinutes?: string[] | null;
    SpecificTimes?: string[] | null;

}

export interface IBookingEnd
{
    SpecificMinutes?: string[] | null;
    SpecificTimes?: string[] | null;

}

export interface IBookingDuration
{
    Minimum?: number;
    Maximum?: number;
    Fixed?: string[] | null;

}

export interface IBookingHorizon
{
    Minimum?: number;
    Maximum?: number;
    BookingOffset?: string | null;

}

export interface IBookingRecurrence
{
    Maximum?: number;
    Allowed?: boolean;

}

export interface IArrivalPolicies
{
    AutoCheckin?: boolean;
    EarlyCheckin?: number;
    AutoCancellation?: number;

}

export interface IApprovalPolicies
{
    ApprovalRequired?: boolean;
    AutoRejectionAfter?: number;
    ApprovalGroups?: string[] | null;

}

export interface IExtendedServices
{
    SpaceSetupManagement?: ISpaceSetupManagement;
    CateringManagement?: ICateringManagement;

}

export interface ISpaceSetupManagement
{
    ManagementType?: string | null;
    User?: string[] | null;
    Group?: string[] | null;

}

export interface ICateringManagement
{
    ManagementType?: string | null;
    User?: string[] | null;
    Group?: string[] | null;

}

export interface IAutomatedTemplate
{
    TemplateId?: string | null;

}

export interface IBookingPolicyApply
{
    SpaceIds?: string[] | null;

}

export interface ISpaceBookRequestV2
{
    Node_Id?: number;
    Space_Layout?: string | null;
    Booking_IsPrivate?: number | null;
    Space_Id?: string | null;
    Booking_Start?: string | null;
    Booking_End?: string | null;
    Booking_Name?: string | null;
    Booking_Description?: string | null;
    Booking_Parties?: IBookingParties[] | null;
    Cost_Code_Allocation?: ICostCodeAllocation[] | null;
    OnBehalfOf?: string | null;
    Booking_AutoCheckIn?: number | null;
    DisableExtUpdate?: boolean;
    Meta_Ext_Booking_Id?: string | null;
    Booking_Host_Name?: string | null;
    Booking_Host_Email?: string | null;
    AddOnlineMeetingLink?: number;
    UseOnBehalfOfCostCodes?: boolean;
    Booking_Setup_Time?: number | null;
    Booking_Tear_Down_Time?: number | null;
    Booking_Dates?: IBookingDetailsRequest[] | null;
    Booking_Attendance?: number;
    Meta_Loc_Zone?: string | null;
    Floor_Name?: string | null;
    Building_Name?: string | null;
    Ticketed_Event_Id?: string | null;
    TemplateId?: string | null;
    ProcessBookingParties?: boolean | null;

}

export interface IBookingParties
{
    Record_Id?: string | null;
    Booking_Participant_Email?: string | null;
    Booking_Participant_Name?: string | null;
    Booking_Participant_Organisation?: string | null;
    Booking_Resource_Id?: string | null;
    Booking_Visitor?: boolean;
    Booking_Participant_Type?: number | null;
    VisitorTypeId?: string | null;
    IsParticipant_On_WaitingList?: number;
    Ticketed_Event_Id?: string | null;

}

export interface ICostCodeAllocation
{
    Cost_Code?: string | null;
    Cost_Code_Id?: string | null;
    Allocation?: number;

}

export interface IBookingDetailsRequest
{
    Node_Id?: number;
    Meta_Ext_Booking_Id?: string | null;
    Space_Layout?: string | null;
    Space_Id?: string | null;
    Booking_Start?: string | null;
    Booking_End?: string | null;
    Booking_Setup_Time?: number | null;
    Booking_Tear_Down_Time?: number | null;
    Booking_AutoCheckIn?: number;
    TemplateId?: string | null;
    Booking_Attendance?: number;

}

export interface IBookingUpdateDetailsRequest
{
    Booking_Details?: IUpdateBookingDetailsRequest[] | null;
    Booking_Description?: string | null;
    Booking_Name?: string | null;
    Booking_IsPrivate?: number | null;
    Booking_Start?: string | null;
    Booking_End?: string | null;
    Space_Id?: string | null;
    DisableExtUpdate?: boolean;
    AddOnlineMeetingLink?: number;
    UseOnBehalfOfCostCodes?: boolean;
    Booking_Setup_Time?: number | null;
    Booking_Tear_Down_Time?: number | null;
    Booking_Attendance?: number;
    Booking_AutoCheckIn?: number | null;
    Ticketed_Event_Id?: string | null;
    ProcessBookingParties?: boolean | null;

}

export interface IUpdateBookingDetailsRequest
{
    StartDate?: string | null;
    EndDate?: string | null;
    Space_Id?: string | null;
    Booking_Id?: string | null;
    Meta_Ext_Booking_Id?: string | null;
    Change?: number | null;
    Booking_Setup_Time?: number | null;
    Booking_Tear_Down_Time?: number | null;

}

export interface IUpdateBookingV2BookingDates
{
    Booking_Details?: IUpdateBookingDetailsRequest[] | null;
    Booking_IsPrivate?: number | null;
    Space_Id?: string | null;
    Booking_Start?: string | null;
    Booking_End?: string | null;
    Booking_Name?: string | null;
    Booking_Description?: string | null;
    Space_Layout?: string | null;
    Organisation?: string | null;
    Booking_Parties?: IBookingParties[] | null;
    Cost_Code_Allocation?: ICostCodeAllocation[] | null;
    DisableExtUpdate?: boolean;
    Meta_Ext_Booking_Id?: string | null;
    OnBehalfOf?: string | null;
    Booking_Host_Name?: string | null;
    Booking_Host_Email?: string | null;
    AddOnlineMeetingLink?: number;
    UseOnBehalfOfCostCodes?: boolean;
    Booking_Setup_Time?: number | null;
    Booking_Tear_Down_Time?: number | null;
    Booking_Attendance?: number;
    Booking_AutoCheckIn?: number | null;
    Ticketed_Event_Id?: string | null;
    ProcessBookingParties?: boolean | null;

}

export interface IPatchUpdate
{
    Booking_Description?: string | null;
    Booking_Name?: string | null;
    Booking_IsPrivate?: number | null;
    Booking_Start?: string | null;
    Booking_End?: string | null;
    Space_Id?: string | null;
    DisableExtUpdate?: boolean;
    AddOnlineMeetingLink?: number;
    UseOnBehalfOfCostCodes?: boolean;
    Booking_Setup_Time?: number | null;
    Booking_Tear_Down_Time?: number | null;
    Booking_Attendance?: number;
    Booking_AutoCheckIn?: number | null;
    Ticketed_Event_Id?: string | null;
    ProcessBookingParties?: boolean | null;

}

export interface IUpdateBookingV2
{
    Booking_IsPrivate?: number | null;
    Space_Id?: string | null;
    Booking_Start?: string | null;
    Booking_End?: string | null;
    Booking_Name?: string | null;
    Booking_Description?: string | null;
    Space_Layout?: string | null;
    Organisation?: string | null;
    Booking_Parties?: IBookingParties[] | null;
    Cost_Code_Allocation?: ICostCodeAllocation[] | null;
    DisableExtUpdate?: boolean;
    Meta_Ext_Booking_Id?: string | null;
    OnBehalfOf?: string | null;
    Booking_Host_Name?: string | null;
    Booking_Host_Email?: string | null;
    AddOnlineMeetingLink?: number;
    UseOnBehalfOfCostCodes?: boolean;
    Booking_Setup_Time?: number | null;
    Booking_Tear_Down_Time?: number | null;
    Booking_Attendance?: number;
    Booking_AutoCheckIn?: number | null;
    Ticketed_Event_Id?: string | null;
    ProcessBookingParties?: boolean | null;

}

export interface ICateringMenuModel
{
    Menu_Id?: string | null;
    Description?: string | null;
    Short_Description?: string | null;
    ImageURI?: string | null;
    Available_From?: string | null;
    Available_Until?: string | null;
    Status?: IBSS_Menu_Status;
    OperationalSettings?: IOperationalSettings;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export type IBSS_Menu_Status = 'StatusInactive' | 'StatusActive';

export interface IOperationalSettings
{
    Monday?: IOperationalDaySetting;
    Tuesday?: IOperationalDaySetting;
    Wednesday?: IOperationalDaySetting;
    Thursday?: IOperationalDaySetting;
    Friday?: IOperationalDaySetting;
    Saturday?: IOperationalDaySetting;
    Sunday?: IOperationalDaySetting;

}

export interface IOperationalDaySetting
{
    CateringCutOff?: string | null;

}

export interface IRelationIdsPut
{
    Add_Ids?: string[] | null;
    Remove_Ids?: string[] | null;

}

export interface IRelationIdsPost
{
    Add_Ids?: string[] | null;

}

export interface ICateringMenuItemModel
{
    MenuItem_Id?: string | null;
    Description?: string | null;
    Classification?: MenuItemClassificationEnum;
    Status?: IBSS_Menu_Status;
    UnitPrice?: number | null;
    RetailPrice?: number | null;
    ImageURI?: string | null;
    NutritionalInformation?: string | null;
    Supplier_Id?: string | null;
    OrderPolicy_Id?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export type MenuItemClassificationEnum = 'MenuItemClassificationBeverage' | 'MenuItemClassificationFood' | 'MenuItemClassificationSnack';

export interface ICateringMenuTemplateModel
{
    Menu_Id?: string | null;
    ImageURI?: string | null;
    Description?: string | null;
    Deleted?: boolean | null;
    MenuItems?: ICateringTemplateMenuItems[] | null;
    MinimumBookingDuration?: number | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface ICateringTemplateMenuItems
{
    MenuItemId?: string | null;

}

export interface ICateringOrderModel
{
    Order_Id?: string | null;
    Node_Id?: number | null;
    Menu_Items?: string | null;
    Booking_Id?: string | null;
    Space_Id?: string | null;
    Catering_Service_Time?: string | null;
    Catering_Clearing_Time?: string | null;
    Catering_Attendees?: number | null;
    Catering_Notes?: string | null;
    Cost_Code_Allocation?: string | null;
    Catering_Total_Value?: number | null;
    Catering_Order_Restrictions?: string | null;
    IsChargeable?: number | null;
    ActionRequired?: number | null;
    IsDeleted?: number | null;
    Catering_Cutoff_Time?: string | null;
    Catering_Order_Status?: string | null;
    IsAutomated?: number | null;

}

export interface ICateringMenu
{
    ImageURI?: string | null;
    Menu_Item_Id?: number;
    Menu_Item_Title?: string | null;
    Menu_Item_Description?: string | null;
    Menu_Item_Section?: string | null;
    Menu_Item_Price?: number;
    Node_Id?: number;
    Catering_Order_Id?: number;
    Space_Id?: string | null;
    Catering_Order_Item_Id?: string | null;
    Catering_Order_Item_Quantity?: string | null;

}

export interface ICateringOrderChargeableModel
{
    IsChargeable?: string | null;

}

export interface ICateringOrderActionRequiredModel
{
    ActionRequired?: string | null;

}

export interface ICateringOrderPolicyModel
{
    OrderPolicy_Id?: string | null;
    OrderPolicy_Ref?: string | null;
    Description?: string | null;
    AdvanceNotice?: string | null;
    PreparationTime_Mins?: number | null;
    Kitchen_OperatingHours_Start?: string | null;
    Kitchen_OperatingHours_Stop?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface ICateringRestrictionModel
{
    Restriction_Id?: string | null;
    Section?: string | null;
    ImageURI?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface ICateringSupplierModel
{
    Supplier_Id?: string | null;
    Description?: string | null;
    AccountManager?: string | null;
    Phone?: string | null;
    Email?: string | null;
    LeadTime?: string | null;
    External_Id?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface IDataPoint
{
    Space_Id?: string | null;
    HasQuantity?: string | null;
    HasSubstance?: string | null;
    SortOrder?: number;
    Enabled?: number;
    DataPointType?: number;
    DataPointDataType?: number;
    ValidationRangeMinimum?: string | null;
    ValidationRangeMaximum?: string | null;
    ValidationRule?: string | null;
    DataCollectionDeviceId?: string | null;
    DataPointName?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface IDataPointVM
{
    Value?: string | null;
    ValueTimestamp?: string | null;

}

export interface IEquipmentV2
{
    ImageURI?: string | null;
    Space_Id?: string | null;
    Meta_Loc_X_m?: number;
    Meta_Loc_Y_m?: number;
    Meta_Loc_Zone?: string | null;
    Meta_Bookable?: number;
    Equip_Name?: string | null;
    Equip_Class?: string | null;
    Equip_Type?: string | null;
    Equip_IsEnabled?: number;
    Meta_Ext_CAFM_System?: number;
    Meta_Ext_CAFM_Id?: string | null;
    Meta_Loc_Height?: number;
    Meta_Loc_Fixed?: number;
    Equip_Comm_By?: string | null;
    Equip_Comm_Date?: string;
    Equip_Install_By?: string | null;
    Equip_Install_Date?: string;
    Equip_Serviced_By?: string | null;
    Equip_Serviced_Date?: string;
    Equip_Maint_Interval_Hrs?: number;
    Equip_Tag_No?: string | null;
    Equip_Serial_No?: string | null;
    Equip_Mfr?: string | null;
    MAC_Address?: string | null;
    IP_Address?: string | null;
    Equip_Last_Status_Change?: string;
    Equip_Last_Updated?: string;
    Store_Space_Id?: string | null;
    Equip_Status?: string | null;
    Equip_UI_Colour?: string | null;
    Equip_Status_Text?: string | null;
    Equip_Category?: string | null;

}

export interface IEquipmentBookingModel
{
    StartDate?: string;
    EndDate?: string;

}

export interface IAvailableEquipment
{
    EquipmentType?: string | null;
    StartDate?: string | null;
    EndDate?: string | null;

}

export interface IExportRequestsCancelRequest
{
    Request_Id?: string | null;

}

export interface IFiltersRequest
{
    Filter_Id?: string | null;
    EventType_Id?: number;
    Filter?: string | null;
    Status?: string | null;
    Building_Bypass?: boolean | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface IHierarchyNodesRequest
{
    ID?: number;
    Name?: string | null;
    Deleted?: boolean;
    DisplayName?: string | null;
    Parent_ID?: number | null;
    TimeZoneDST?: number | null;
    IsEnabled?: number | null;
    SortOrder?: string | null;
    Level?: string | null;
    TimeZone?: string | null;
    TimeZoneType?: string | null;
    MapURI?: string | null;
    ImageURI?: string | null;
    Agents?: IAgents;
    Physical_Properties?: IPhysicalProperties;
    Node_Search_Config?: INode_Search_Config;
    Location?: ILocation;

}

export interface IAgents
{
    Owner?: string | null;
    Operator?: string | null;
    Occupier?: string | null;

}

export interface IPhysicalProperties
{
    Capacity?: string | null;
    Size?: string | null;

}

export interface INode_Search_Config
{
    config?: string | null;

}

export interface ILocation
{
    Address?: string | null;
    City?: string | null;
    Country?: string | null;
    Longitude?: string | null;
    Latitude?: string | null;

}

export interface IHierarchyNodesPatchRequest
{
    ID?: number;
    Name?: string | null;
    Deleted?: boolean;
    DisplayName?: string | null;
    Parent_ID?: number | null;
    IsEnabled?: number | null;
    SortOrder?: string | null;
    Level?: string | null;
    TimeZone?: string | null;
    TimeZoneType?: string | null;
    TimeZoneDST?: number | null;
    MapURI?: string | null;
    ImageURI?: string | null;
    Agents?: IAgents;
    Physical_Properties?: IPhysicalProperties;
    Node_Search_Config?: INode_Search_Config;
    Location?: ILocation;

}

export interface INotesRequestModel
{
    Note_Id?: string | null;
    Node_Id?: number;
    EventType_Id?: number;
    Event_Id?: string | null;
    EventType_Name?: string | null;
    Note?: string | null;
    IsDeleted?: number;

}

export interface INotesSoftDeleteRequest
{
    IsDeleted?: number;

}

export interface INotificationReminder
{
    EventType_Id?: number;
    Status?: string | null;
    NotificationDuration?: string | null;
    TimeOfDay?: string | null;
    Filter?: string | null;
    BuiltInRule?: number;
    CustomData?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface INotificationReminderEnable
{
    Reminder_Id?: string | null;

}

export interface INotificationReminderDisable
{
    Reminder_Id?: string | null;

}

export interface IResolverCategory
{
    Task_Category_Id?: string | null;
    Task_Category_Name?: string | null;
    Resolver_Group_Name?: string | null;

}

export interface IShortcutsRequestModel
{
    SignPostType?: string | null;
    KPIType?: number | null;
    Units?: string | null;
    Label?: string | null;
    MaximumCount?: string | null;
    BuildingKPI_Limit1?: number | null;
    BuildingKPI_Limit2?: number | null;
    BuildingKPI_Text0?: string | null;
    BuildingKPI_Text1?: string | null;
    BuildingKPI_Text2?: string | null;
    BuildingKPI_Value?: number | null;
    ValueURI?: string | null;
    Icon?: string | null;
    ActionLabel?: string | null;
    ActionURI?: string | null;
    BuildingKPI_Order?: number | null;
    Heading?: string | null;
    SubHeading?: string | null;
    Application?: string[] | null;
    Image?: string | null;
    StartDate?: string | null;
    EndDate?: string | null;
    Destination?: IDestination;
    IsEnabled?: number | null;

}

export interface IDestination
{
    Web?: string | null;
    Android?: string | null;
    iOS?: string | null;

}

export interface IShortcutsEnableRequest
{
    ShortcutIds?: string[] | null;

}

export interface ISpace
{
    Space_AV_Source_Scenes?: string | null;
    Space_Light_Scenes?: string | null;
    Space_Light_Mode?: number;
    Env_Temperature_Range?: number;
    Env_Sound_Level_Range?: number;
    Space_Id?: string | null;
    Space_Name?: string | null;
    Space_Class?: string | null;
    Space_Type?: string | null;
    Space_Type_Label?: string | null;
    Space_Name_Label?: string | null;
    Space_Capacity?: number | null;
    Env_Zone_Id?: number;
    Meta_Loc_Zone?: string | null;
    Meta_Bookable?: number | null;
    Meta_Loc_X_m?: number;
    Meta_Loc_Y_m?: number;
    Meta_Space_DurationMin_min?: number;
    Meta_Space_DurationMax_min?: number;
    Space_ReservationMins?: number;
    Meta_Occ_Type?: number | null;
    Meta_Sol_Thld_Min?: number;
    Meta_Dig_Sign_Type?: number;
    Meta_Clean_Thld_Min?: number;
    ImageURI?: string | null;
    Meta_Ext_Occ_System?: number;
    Meta_Ext_Occ_Count_Mode?: number;
    Meta_Ext_Occ_Area_Id?: string | null;
    Meta_Ext_Occ_Sensor_Id?: string | null;
    Space_Work_Type?: string | null;
    Space_IsEnabled?: number | null;
    Meta_Ext_Booking_System?: string | null;
    Meta_Ext_Catering_Space_Id?: string | null;
    Meta_Avail_Serv_Reqs?: number | null;
    Meta_Ext_Booking_Space_Id?: string | null;
    Meta_Ext_Catering_System?: string | null;
    Space_UI_Colour?: string | null;
    Space_Custom_Info?: string | null;
    Space_Arrival_Loc?: number | null;
    Meta_Gtwy?: string | null;
    Meta_Gtwy_Type?: number;
    Meta_No_Bkng_Sol_Thld_Min?: number;
    Space_Setup?: number;
    Space_Layout?: string | null;
    Booking_Policy_Id?: string | null;

}

export interface ISpacePatch
{
    Space_AV_Source_Scenes?: string | null;
    Space_Light_Scenes?: string | null;
    Space_Light_Mode?: number | null;
    Env_Temperature_Range?: number | null;
    Env_Sound_Level_Range?: number | null;
    Space_Id?: string | null;
    Space_Name?: string | null;
    Space_Class?: string | null;
    Space_Type?: string | null;
    Space_Type_Label?: string | null;
    Space_Name_Label?: string | null;
    Space_Capacity?: number | null;
    Env_Zone_Id?: number | null;
    Meta_Loc_Zone?: string | null;
    Meta_Bookable?: number | null;
    Meta_Loc_X_m?: number | null;
    Meta_Loc_Y_m?: number | null;
    Meta_Space_DurationMin_min?: number | null;
    Meta_Space_DurationMax_min?: number | null;
    Space_ReservationMins?: number | null;
    Meta_Occ_Type?: number | null;
    Meta_Sol_Thld_Min?: number | null;
    Meta_Dig_Sign_Type?: number | null;
    Meta_Clean_Thld_Min?: number | null;
    ImageURI?: string | null;
    Meta_Ext_Occ_System?: number | null;
    Meta_Ext_Occ_Count_Mode?: number | null;
    Meta_Ext_Occ_Area_Id?: string | null;
    Meta_Ext_Occ_Sensor_Id?: string | null;
    Space_Work_Type?: string | null;
    Space_IsEnabled?: number | null;
    Meta_Ext_Booking_System?: string | null;
    Meta_Ext_Catering_Space_Id?: string | null;
    Meta_Avail_Serv_Reqs?: number | null;
    Meta_Ext_Booking_Space_Id?: string | null;
    Meta_Ext_Catering_System?: string | null;
    Space_UI_Colour?: string | null;
    Space_Custom_Info?: string | null;
    Space_Arrival_Loc?: number | null;
    Meta_Gtwy?: string | null;
    Meta_Gtwy_Type?: number | null;
    Meta_No_Bkng_Sol_Thld_Min?: number | null;
    Space_Setup?: number | null;
    Space_Layout?: string | null;
    Booking_Policy_Id?: string | null;

}

export interface ISearchRecurring
{
    Booking_Dates?: IBookingDates[] | null;
    TimeInclusive?: boolean;
    Space_Capacity?: number;
    Space_Type?: string | null;
    Space_Work_Type?: string | null;
    Meta_Serv_Reqs_AV?: number | null;
    Meta_Serv_Reqs_Catering?: number | null;
    Meta_Serv_Reqs_Hearing?: number | null;
    Meta_Serv_Reqs_Presentation?: number | null;
    Meta_Serv_Reqs_Event?: number | null;
    Floor_Id?: number | null;
    Meta_Loc_Zone?: string | null;
    Space_Setup?: number | null;
    Primary?: IPrimaryDelegates;

}

export interface IBookingDates
{
    Start_Time?: string;
    End_Time?: string;

}

export interface IPrimaryDelegates
{
    Primary_Email?: string | null;
    Primary_User_Id?: string | null;

}

export interface ISpaceDisableVM
{
    Space_Id?: string | null;
    Node_Id?: number;

}

export interface ISpaceEnableVM
{
    Space_Id?: string | null;
    Node_Id?: number;

}

export interface ISpaceBookingActionVM
{
    BookingOwnerEmail?: string | null;
    BookingOwnerPIN?: string | null;

}

export interface ISpacesConfigurationRequest
{
    Space_Id?: string | null;
    Space_Name?: string | null;
    Space_Name_Label?: string | null;
    Space_Capacity?: number | null;
    Space_IsEnabled?: number | null;
    Space_Work_Type?: string | null;
    Space_Type?: string | null;
    Space_Class?: string | null;
    ImageURI?: string | null;
    Space_UI_Colour?: string | null;
    Env_Zone_Id?: number | null;
    Space_Custom_Info?: string | null;
    Space_Type_Label?: string | null;
    Space_Arrival_Loc?: number | null;
    Space_Setup?: number | null;
    Space_Layout?: string | null;
    Meta_Gtwy?: string | null;
    Meta_Gtwy_Type?: number | null;
    Meta_Loc_X_m?: number | null;
    Meta_Loc_Y_m?: number | null;
    Meta_Loc_Zone?: string | null;
    Meta_Occ_Type?: number | null;
    Meta_Ext_Occ_System?: number | null;
    Meta_Ext_Occ_Count_Mode?: number | null;
    Meta_Ext_Occ_Area_Id?: string | null;
    Meta_Ext_Occ_Sensor_Id?: string | null;
    Meta_Space_DurationMin_min?: number | null;
    Meta_Space_DurationMax_min?: number | null;
    Meta_Ext_Booking_System?: string | null;
    Meta_Ext_Catering_Space_Id?: string | null;
    Meta_Bookable?: number | null;
    Meta_Dig_Sign_Type?: number | null;
    Meta_Sol_Thld_Min?: number | null;
    Meta_Avail_Serv_Reqs?: number | null;
    Meta_Ext_Booking_Space_Id?: string | null;
    Meta_Clean_Thld_Min?: number | null;
    Meta_Ext_Catering_System?: string | null;
    Meta_Serv_Reqs_Catering?: number | null;
    Meta_Serv_Reqs_AV?: number | null;
    Meta_No_Bkng_Sol_Thld_Min?: number | null;
    Meta_Serv_Reqs_Presentation?: number | null;
    Meta_Serv_Reqs_Hearing?: number | null;
    Meta_Serv_Reqs_Event?: number | null;
    Booking_Policy_Id?: string | null;
    Env_Sound_Level_Range?: number | null;
    Env_Temperature_Range?: number | null;
    Node_Id?: number | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface ISpacesConfigurationRequestPatch
{
    Space_Id?: string | null;
    Space_Name?: string | null;
    Space_Name_Label?: string | null;
    Space_Capacity?: number | null;
    Space_IsEnabled?: number | null;
    Space_Work_Type?: string | null;
    Space_Type?: string | null;
    Space_Class?: string | null;
    ImageURI?: string | null;
    Space_UI_Colour?: string | null;
    Env_Zone_Id?: number | null;
    Space_Custom_Info?: string | null;
    Space_Type_Label?: string | null;
    Space_Arrival_Loc?: number | null;
    Space_Setup?: number | null;
    Space_Layout?: string | null;
    Meta_Gtwy?: string | null;
    Meta_Gtwy_Type?: number | null;
    Meta_Loc_X_m?: number | null;
    Meta_Loc_Y_m?: number | null;
    Meta_Loc_Zone?: string | null;
    Meta_Occ_Type?: number | null;
    Meta_Ext_Occ_System?: number | null;
    Meta_Ext_Occ_Count_Mode?: number | null;
    Meta_Ext_Occ_Area_Id?: string | null;
    Meta_Ext_Occ_Sensor_Id?: string | null;
    Meta_Space_DurationMin_min?: number | null;
    Meta_Space_DurationMax_min?: number | null;
    Meta_Ext_Booking_System?: string | null;
    Meta_Ext_Catering_Space_Id?: string | null;
    Meta_Bookable?: number | null;
    Meta_Dig_Sign_Type?: number | null;
    Meta_Sol_Thld_Min?: number | null;
    Meta_Avail_Serv_Reqs?: number | null;
    Meta_Ext_Booking_Space_Id?: string | null;
    Meta_Clean_Thld_Min?: number | null;
    Meta_Ext_Catering_System?: string | null;
    Meta_Serv_Reqs_Catering?: number | null;
    Meta_Serv_Reqs_AV?: number | null;
    Meta_No_Bkng_Sol_Thld_Min?: number | null;
    Meta_Serv_Reqs_Presentation?: number | null;
    Meta_Serv_Reqs_Event?: number | null;
    Meta_Serv_Reqs_Hearing?: number | null;
    Booking_Policy_Id?: string | null;
    Env_Sound_Level_Range?: number | null;
    Env_Temperature_Range?: number | null;
    Node_Id?: number | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface ISpacesConfigurationRequestPatchOwner
{
    Node_Id?: number | null;
    SpaceIds?: string[] | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;

}

export interface ITag2EventTypeRequest
{
    Tag2EventType_Id?: string | null;
    Tag_Id?: string | null;
    EventType_Id?: number;
    TagType?: string | null;
    Name?: string | null;
    Value?: string | null;
    Icon?: string | null;
    Node_Id?: number;
    Record_Id?: string | null;
    CreatedBy?: string | null;
    CreatedAt?: string;
    ModifiedBy?: string | null;
    ModifiedAt?: string;

}

export interface ITagDefinitionsModel
{
    Tag_Id?: string | null;
    TagType?: string | null;
    Values?: string | null;
    Icon?: string | null;
    Description?: string | null;
    Status?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface ITaskCategories
{
    ImageURI?: string | null;
    Space_Type?: string | null;
    Task_Category_Name?: string | null;
    Task_Category_IsEnabled?: number;
    Equip_Type?: string | null;

}

export interface ITaskCategories_PUT
{
    ImageURI?: string | null;
    Space_Type?: string | null;
    Task_Category_IsEnabled?: number | null;
    Equip_Type?: string | null;

}

export interface ITaskCategoryEnable
{
    Task_Category_Id?: string | null;

}

export interface ITaskCategoryDisable
{
    Task_Category_Id?: string | null;

}

export interface ITasksV2Create
{
    Space_Id?: string | null;
    Task_Category_Id?: number;
    Task_Type_Id?: number;
    Task_Description?: string | null;
    Task_Priority?: number | null;
    Equipment_Id?: string | null;
    Booking_Id?: string | null;
    DisableExtUpdate?: boolean;
    Cost_Code_Allocation?: ICostCodeAllocation[] | null;

}

export interface ITaskV2Update
{
    Task_Priority?: number | null;
    Task_Description?: string | null;
    Task_Resolve_Description?: string | null;
    Cost_Code_Allocation?: ICostCodeAllocation[] | null;

}

export interface ITasksCancel
{
    DisableExtUpdate?: boolean;
    TaskResolveDescription?: string | null;

}

export interface ITasksExcludeFromCalcsVM
{
    Exclude_From_Calcs?: number;

}

export interface ITaskReAllocate
{
    Resolver_Id?: string | null;
    Priority?: number;

}

export interface ITasksAssign
{
    Resolver_Id?: string | null;

}

export interface ITaskResolve
{
    TaskResolveDescription?: string | null;

}

export interface ITaskPriority
{
    Priority?: number;

}

export interface ITaskComment
{
    Message?: string | null;
    UserName?: string | null;

}

export interface ITaskType
{
    Task_Category_Id?: string | null;
    Task_Type_Name?: string | null;
    Task_Type_Priority?: number;
    Task_Type_Resolve_Duration?: number;
    Task_Type_Priority_Resolve_Duration?: number;
    Task_IsDefault_Space_Clean_Task?: number | null;
    Task_Type_IsEnabled?: number;
    Space_Type?: string | null;
    Task_Type_Add_Details?: number | null;
    Task_IsDefault_Catering_Task?: number | null;
    Task_Type_Requires_Cost_Code?: number;
    Equip_Type?: string | null;
    Meta_Ext_Task_Type_Id?: string | null;

}

export interface ITaskTypeEnable
{
    Task_Type_Id?: string | null;

}

export interface ITaskTypeDisable
{
    Task_Type_Id?: string | null;

}

export interface ITicketedEventsRequest
{
    Ticketed_Event_Id?: string | null;
    Node_Id?: number;
    Booking_Id?: string | null;
    Event_Owner?: string | null;
    Event_Title?: string | null;
    Event_Short_Description?: string | null;
    Event_Description?: string | null;
    WebSite_URL?: string | null;
    Phone?: string | null;
    IsCatering_Available?: number;
    ImageURI?: string | null;
    Event_Date?: string;
    Event_Start_DateTime?: string;
    Event_End_DateTime?: string;
    Event_Capacity?: number;
    IsManageBy_3rdParty?: number;
    IsWaitingList_Allowed?: number;
    IsCost_Associated?: number;
    Invite_Permission?: string | null;
    Ticket_Price?: number | null;
    IsBroadcast_ToIBSS?: number;
    IsAttendees_CheckingIn?: number;
    IsDraft?: number | null;

}

export interface ITicketedEventPatchRequest
{
    IsCatering_Available?: number | null;
    Event_Date?: string | null;
    Event_Start_DateTime?: string | null;
    Event_End_DateTime?: string | null;
    Event_Capacity?: number | null;
    IsManageBy_3rdParty?: number | null;
    IsWaitingList_Allowed?: number | null;
    IsCost_Associated?: number | null;
    Ticket_Price?: number | null;
    IsBroadcast_ToIBSS?: number | null;
    IsAttendees_CheckingIn?: number | null;
    IsDraft?: number | null;
    Event_Status?: string | null;
    Ticketed_Event_Id?: string | null;
    Node_Id?: number;
    Booking_Id?: string | null;
    Event_Owner?: string | null;
    Event_Title?: string | null;
    Event_Short_Description?: string | null;
    Event_Description?: string | null;
    WebSite_URL?: string | null;
    Phone?: string | null;
    ImageURI?: string | null;
    Invite_Permission?: string | null;

}

export interface ITicketedEventCancelRequest
{
    Ticketed_Event_Id?: string | null;

}

export interface INotificationStatusV2
{
    Notification_Read_Status?: string | null;

}

export interface IUserPin
{
    PIN?: string | null;
    UserName?: string | null;

}

export interface IVisitorType
{
    Description?: string | null;
    Icon?: string | null;
    VisitorTypeWorkFlow?: IVisitorTypeWorkFlowVM;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface IVisitorTypeWorkFlowVM
{
    Steps?: IQuestionSteps[] | null;

}

export interface IQuestionSteps
{
    Step?: string | null;
    Description?: string | null;
    Questions?: IQuestion[] | null;

}

export interface IQuestion
{
    Id?: string | null;
    InputType?: InputType;
    Name?: string | null;
    HelperText?: string | null;
    Value?: string | null;
    goto?: string | null;
    Required?: boolean;
    MaxLength?: string | null;
    PlaceHolderText?: string | null;
    InputHeight?: string | null;
    PolicyText?: string | null;
    RequiredConfirmation?: boolean;
    ConfirmationText?: string | null;
    QuestionName?: string | null;
    Labels?: IQuestionLabel[] | null;
    Answers?: IAnswers[] | null;

}

export type InputType = 'QuestionTypeTrueFalse' | 'QuestionTypeOpen' | 'QuestionTypePolicy' | 'QuestionTypeMultiOptionSingleSelect' | 'NonQuestionTypeHeader' | 'NonQuestionTypeSubHeader' | 'NonQuestionTypeImage';

export interface IQuestionLabel
{
    Label?: string | null;
    goto?: string | null;

}

export interface IAnswers
{
    ModifiedBy?: string | null;
    ModifiedAt?: string | null;
    Value?: string | null;

}

export interface IPostVisitV2
{
    Visitor_First_Name?: string | null;
    Visitor_Last_Name?: string | null;
    Visitor_Email?: string | null;
    Visitor_Company?: string | null;
    Visit_Host_Name?: string | null;
    Visit_Host_Email?: string | null;
    Visit_Start_Date?: string;
    Visit_End_Date?: string;
    Visit_Approval_Comments?: string | null;
    Visitor_Dietary_Pref?: number;
    Visit_Pacs_Id?: string | null;
    Visit_Save_Info?: number;
    Space_Name?: string | null;
    Space_Id?: string | null;
    VisitorTypeId?: string | null;

}

export interface IPatchVisit
{
    Visitor_First_Name?: string | null;
    Visitor_Last_Name?: string | null;
    Visitor_Email?: string | null;
    Visitor_Company?: string | null;
    Visit_Host_Name?: string | null;
    Visit_Host_Email?: string | null;
    Visit_Start_Date?: string | null;
    Visit_End_Date?: string | null;
    Visit_Approval_Comments?: string | null;
    Visitor_Dietary_Pref?: number | null;
    Visit_Pacs_Id?: string | null;
    Visit_Save_Info?: number | null;
    Space_Name?: string | null;
    Space_Id?: string | null;
    VisitorTypeId?: string | null;
    VisitorTypeWorkflow?: IVisitorTypeWorkFlowVM;

}

export interface IPutVisitV2
{
    Visitor_First_Name?: string | null;
    Visitor_Last_Name?: string | null;
    Visitor_Email?: string | null;
    Visitor_Company?: string | null;
    Visit_Host_Name?: string | null;
    Visit_Host_Email?: string | null;
    Visit_Start_Date?: string;
    Visit_End_Date?: string;
    Visit_Approval_Comments?: string | null;
    Visitor_Dietary_Pref?: number;
    Visit_Pacs_Id?: string | null;
    Visit_Save_Info?: number;
    Space_Name?: string | null;
    Space_Id?: string | null;
    VisitorTypeId?: string | null;
    VisitorTypeWorkflow?: IVisitorTypeWorkFlowVM;

}

export type PassDevice = 'Apple' | 'Google';

export interface IDenyVisitModel
{
    Visit_Id?: string | null;
    Visit_Denial_Comment?: string | null;

}

export interface IVisitActionModel
{
    Visit_Id?: string | null;
    Visit_Pacs_Id?: string | null;
    VisitorTypeWorkflow?: IVisitorTypeWorkFlowVM;

}

export interface IApproveVisitModel
{
    Visit_Id?: string | null;
    Visit_Approve_Comment?: string | null;

}
